import { element } from 'protractor';
import { Component, ViewChild, TemplateRef, OnInit, Inject, Injectable, OnChanges, ElementRef, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { MacroService } from '../../shared/services/macro.service';
import { FechaService } from '../../shared/fecha/fecha.service';
import { AlertaService } from '../../alerta/alerta.service';
import { Actividad } from '../../shared/models/actividad.model';
import { DataTableResource } from '../../shared/data-table';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import { type } from 'os';
import { ChangeDetectorRef, AfterContentChecked } from '@angular/core'
import { TimeoutError } from 'rxjs';
import { c } from '@angular/core/src/render3';
import { error } from 'console';

@Component({
	selector: 'app-por-formulario',
	templateUrl: './por-formulario.component.html',
	styleUrls: ['../../app.component.css', './por-formulario.component.css']
})

export class PorFormularioComponent implements OnInit, AfterContentChecked, OnDestroy {

	@ViewChild('viewActivity') private viewrActivity: TemplateRef<any>;

	@ViewChild('newActivity') private newActivityModal: TemplateRef<any>;

	@ViewChild('modalhistorico') private modalhistorico: TemplateRef<any>;

	@ViewChild('tarearapida') private tareaRapidaModal: TemplateRef<any>;

	@ViewChild('modalCamposRequeridos') private modalCamposRequeridos: TemplateRef<any>;

	modalRef: BsModalRef;

	public loading = false;

	idActivityNew = '';
	todayCreation = new Date();
	fechaHoraActualTareaR;

	maxImageFileSizeInMB = 1; // tamaño máximo permitido para imágenes en megabytes
	maxVideoFileSizeInMB = 5; // tamaño máximo permitido para videos en megabytes

	fileSizeError = false;

	editarActividad = false;
	redireccionarActividad = false;
	historialesActividad = false;
	nuevaActividad = false;
	guardandoActividad = false;

	empresasBusqueda = [];
	campoBusqueda;
	zonasBusqueda = [];
	campoBusquedaZona;
	formulariosBusqueda = [];
	campoBusquedaFormulario;
	usuariosBusqueda = [];
	campoBusquedaUsuario;
	estadosBusqueda = [];
	campoBusquedaEstado;
	ubicacionesBusqueda = [];
	camposRequeridosVacios: string[] = [];
	campoBusquedaUbicacion;

	// Cronometro automatico del formulario: ver iniciarCronometro()/alVencerCronometro().
	cronometroVisible = false;
	cronometroTexto = '';
	cronometroCritico = false;
	cronometroVencido = false;
	private cronometroDeadline = 0;
	private cronometroTick: any;
	private cronometroRevalidacion: any;
	// Ultima vez que el usuario escribio/cambio algo mientras el cronometro estaba vencido; evita
	// finalizar apenas el campo obligatorio deja de estar vacio (p.ej. con la primera letra tecleada).
	private cronometroUltimaActividad = 0;
	private static readonly CRONOMETRO_DEBOUNCE_MS = 3000;
	formularioToNewActivity;
	cargaFirmaNewActiviy: boolean = false;
	ubicacionesEmpresa = null;

	paginab = null;
	elementob = null;
	maestrob = null;
	elementoMaestrob = null;

	idEmpresa;
	perfiles;

	lat: string;
	lng: string;
	zoom: number;

	empresas = [];
	usuarios = [];
	zonas = [];
	ubicaciones = [];

	formularios = [];
	actividad = [];
	historicoTarea = [];
	historicoActividad = [];
	historicoEstadosActividad = [];

	fechaInicioModel = null;
	fechaFinalModel = null;
	tipoFechaModel = 0;
	mostrar: boolean = true;

	actividadSeleccionada = null;
	formularioActividadSeleccionada = null;
	estadosActividadFormularioActividadSeleccionada = [];
	estadosFormularioSeleccionadoBusqueda = [];
	paginas = [];
	numerosPagina = [];
	paginaActual = 0;
	informacionPagina;
	ubicacionAsociadaG;

	itemResource = new DataTableResource([]);
	items = [];
	itemCount = 0;
	numeroPaginaSelccionada = "0";
	cantidadElementos = [];
	selectedFile: File;
	fileVerication: File;
	macroFiles = 'https://s3.us-east-2.amazonaws.com/macro-files-dev/';

	idmaActivo: boolean = false;
	crud: boolean = false;
	crm: boolean;
	empresasAsociadas: string;
	buscadorActividades: boolean = false;
	tareaCrearActualizar;
	today;
	horas = [];
	minutos = [];
	nota;
	idNota;
	idUsuarioLog;
	myUsuario;
	idUsuario;
	usuarioMixto: boolean = false;
	usuarioGregario: boolean = false;
	usuarioinvitado: boolean = false;
	verHistoricoActividad: boolean = false;
	cargandoHistoricoActividades: boolean = false;
	historicoActividades = [];
	nombreUsuarioLog;
	zonaTrabajo = "";
	activitiesSelectedToDelete: string[] = [];
	estados: any[] = [];
	formularioSeleccionado;

	tareaR;
	usuarioTR;
	fechainicio;
	fechafin;
	formInvalido;
	fecharepeticion;
	horaInicio;
	horaFin;
	permisoTareas = false;
	mostrarFiltros = true;

	redespacho = false;
	empresaEdemco = false;

	@HostListener('window:beforeunload', ['$event'])
	antesDeDescargar(event: any): any {
		if (this.nuevaActividad && this.idActivityNew) {
			const mensaje = 'Tiene una actividad en creación sin guardar. Si sale, se eliminará.';
			event.returnValue = mensaje;
			event.preventDefault();
			return mensaje;
		}
	}

	@HostListener('window:unload')
	alDescargar() {
		this.eliminarActividadPendiente();
	}

	@HostListener('document:visibilitychange')
	alCambiarVisibilidad() {
		if (document.visibilityState === 'hidden') {
			this.eliminarActividadPendiente();
		}
	}

	private eliminarActividadPendiente() {
		if (this.nuevaActividad && this.idActivityNew) {
			const url = 'https://macro-ma-cloud.macrosistemasapp.com/actividades/eliminar';
			const body = JSON.stringify([this.idActivityNew]);
			const headers = {
				'Content-Type': 'application/json',
				'mtkn': this.storage.get('idma') || '',
				'sourceR': 'web'
			};
			fetch(url, { method: 'POST', body: body, headers: headers, keepalive: true });
		}
	}

	constructor(
		@Inject(MacroService) public macroService: MacroService,
		@Inject(AlertaService) private servicioAlerta: AlertaService,
		@Inject(FechaService) private fechaService: FechaService,
		private modalService: BsModalService,
		@Inject(LOCAL_STORAGE) private storage: WebStorageService,
		private router: Router, private changeDetector: ChangeDetectorRef) { }

	ngOnDestroy() {
		this.detenerCronometro();
		if (this.nuevaActividad && this.idActivityNew) {
			this.macroService.elimiarActividades([this.idActivityNew]).subscribe();
		}
	}

	ngOnInit() {
		this.usuarioinvitado = this.storage.get("uinvi") === "true";
		this.idEmpresa = this.storage.get("idem");
		if (this.idEmpresa === '117') {
			this.empresaEdemco = true;
		}
		this.perfiles = this.storage.get("nmper");
		this.today = new Date();
		this.idUsuarioLog = this.storage.get("nmus");
		this.nombreUsuarioLog = this.storage.get("nomus");
		let month = (this.today.getMonth() + 1) > 9 ? (this.today.getMonth() + 1) : '0' + (this.today.getMonth() + 1);
		let day = this.today.getDate() > 9 ? this.today.getDate() : '0' + this.today.getDate();
		this.today = this.today.getFullYear() + '-' + month + '-' + day;
		this.idmaActivo = this.storage.get("idma") !== null;
		this.crm = this.storage.get('crm');
		this.empresasAsociadas = this.storage.get('asocem');
		if (!this.idmaActivo || this.idmaActivo === undefined || this.idmaActivo === null) {
			this.router.navigate(['session/iniciar']);
			return;
		}
		this.crud = this.perfiles.indexOf('crud') > -1;
		this.formulariosBusqueda = [];
		this.fechaInicioModel = this.fechaService.obtenerFormatoDateAnterior();
		this.fechaFinalModel = this.fechaService.obtenerFormatoDateActual();
		this.consultarUsuario();				
		this.campoBusqueda = "";
		this.campoBusquedaFormulario = "";
		this.items = [];
		this.activitiesSelectedToDelete = [];
		this.usuarioTR = false;
	}

	private verificarPermiso() {
		for (let nombreperfil of this.perfiles) {
			this.macroService.consultarPerfilPorNombre(nombreperfil).subscribe(obj => {
				this.buscadorActividades = !this.buscadorActividades ? obj.nombressegmento !== null && obj.nombressegmento.indexOf("Buscador Actividades") > -1 : this.buscadorActividades;
				if (obj.nombressegmento !== null && obj.nombressegmento.indexOf('Conf. segmentacion Tarea') > -1) {
					this.permisoTareas = true;
				}
			});
		}
	}

	busquedaEmpresa() {
		if (this.campoBusqueda !== undefined && this.campoBusqueda.length > 0) {
			this.empresasBusqueda = this.empresas.filter(empresa => empresa.nombre.toLowerCase().indexOf(this.campoBusqueda.toLowerCase()) !== -1);
			if (this.empresasBusqueda.length === 1) {
				this.idEmpresa = this.empresasBusqueda[0].idempresa;
				this.inicializacionInformacion(this.idEmpresa);
			}
		}
	}

	busquedaZona() {
		if (this.campoBusquedaZona !== undefined && this.campoBusquedaZona.length > 0) {
			this.zonasBusqueda = this.zonas.filter(zona => zona.nombre.toLowerCase().indexOf(this.campoBusquedaZona.toLowerCase()) !== -1);
		}
	}

	busquedaUbicacion() {
		if (this.campoBusquedaUbicacion !== undefined && this.campoBusquedaUbicacion.length > 0) {
			this.ubicacionesBusqueda = this.ubicaciones.filter(ubicacion => ubicacion.nombre.toLowerCase().indexOf(this.campoBusquedaUbicacion.toLowerCase()) !== -1);
		}
	}

	busquedaFormulario() {
		if (this.campoBusquedaFormulario !== undefined && this.campoBusquedaFormulario.length > 0) {
			this.formulariosBusqueda = this.formularios.filter(formulario => formulario.nombre.toLowerCase().indexOf(this.campoBusquedaFormulario.toLowerCase()) !== -1);
		}
	}

	busquedaEstado() {
		if (this.campoBusquedaEstado !== undefined && this.campoBusquedaEstado.length > 0) {
			this.estadosBusqueda = this.estados.filter(estado => estado.nombre.toLowerCase().indexOf(this.campoBusquedaEstado.toLowerCase()) !== -1);
		}
	}

	busquedaUsuario() {
		if (this.campoBusquedaUsuario !== undefined && this.campoBusquedaUsuario.length > 0) {
			this.usuariosBusqueda = this.usuarios.filter(usuario => usuario.nombreusuario.toLowerCase().indexOf(this.campoBusquedaUsuario.toLowerCase()) !== -1);
		} else {
			this.usuariosBusqueda = this.usuarios;
		}
	}

	inicializacionInformacion(idEmpresa) {
		this.cancelarNuevaActividad();
		this.idEmpresa = idEmpresa;
		this.usuarioinvitado = this.storage.get("uinvi") === "true";
		if (this.usuarioMixto) {
			this.cargarZonasPorUsuario();
			this.consultarFormulariosPorUsuario(this.nombreUsuarioLog);
		} else if (this.usuarioGregario || this.usuarioinvitado) {
			this.cargarZonasPorUsuario();
			this.zonasBusqueda = this.zonas;
			this.consultarFormulariosPorUsuario(this.nombreUsuarioLog); // consulta los FORMULARIOS asociados al usuario
			this.inicializacionInformacionUbicaciones(this.myUsuario.zonaTrabajo); // consulta las UBICACIONES segun la zona asiganada al cliente
		} else if (this.crm || this.empresasAsociadas != this.idEmpresa) {
			this.consultarUsuariosPorCliente(this.idEmpresa);
			this.consultarFormulariosPorCliente(this.idEmpresa);
			this.consultarUbicacionesPorCliente(this.idEmpresa);
			this.consultarZonasPorCliente(this.idEmpresa); // consulta ZONAS por cliente
		} else {
			this.consultarUsuariosPorCliente(this.idEmpresa);
			this.consultarFormulariosPorUsuario(this.nombreUsuarioLog);			
			this.consultarUbicacionesPorCliente(this.idEmpresa);
			this.consultarZonasPorCliente(this.idEmpresa); // consulta ZONAS por cliente
		}
		this.consultarEstadosPorCliente(this.idEmpresa);
	}

	private cargarZonasPorUsuario() {
		this.zonas.push({ "idzonatrabajo": this.myUsuario.zonaTrabajo, "nombre": this.myUsuario.zonaTrabajoDescripcion });
		for (let zonaSec of this.myUsuario.zonasSecundarias) {
			this.zonas.push(zonaSec);
		}
	}

	consultarUsuario() {
		this.loading = true;
		this.macroService.consultarUsuario2(this.idUsuarioLog).subscribe(
			data => {
				this.myUsuario = data;
				if (this.myUsuario.administradormixto === undefined || this.myUsuario.administradormixto === null || this.myUsuario.administradormixto === 'false') {
					this.usuarioMixto = false;
				} else {
					this.usuarioMixto = true;
					this.idUsuario = this.myUsuario.idusuario;
				}

				if (this.myUsuario.administradorgregario === undefined || this.myUsuario.administradorgregario === null || this.myUsuario.administradorgregario === 'false') {
					this.usuarioGregario = false;
				} else {
					this.usuarioGregario = true;
					this.zonaTrabajo = this.myUsuario.zonaTrabajo;
				}

				if (this.usuarioinvitado) {
					this.zonaTrabajo = this.myUsuario.zonaTrabajo;
				}

				this.verificarPermiso();
				this.inicializacionInformacion(this.idEmpresa);
				this.loading = false;
				if (this.crm) {
					this.ejecucionUsuarioCRM();
				} 
				//Caso especial solamente para EPM.
				if (this.idEmpresa == "196") {
					this.consultarEmpresas()
				}
			}, err => {
				console.error(err);
			}
		);
	}

	inicializacionInformacionUbicaciones(idZona) {
		if (idZona && idZona > 0) {
			this.consultarUbicacionesPorClienteZona(this.idEmpresa, idZona);
		}
		if (this.usuarioinvitado || this.usuarioGregario) {
			this.consultarUsuariosPorClienteZona(this.idEmpresa, idZona);
		}
	}

	validarFormulario(form: any) {
		if (!this.fechaInicioModel || this.fechaInicioModel == null || (this.fechaInicioModel && this.fechaInicioModel.length === 0)
			|| !this.fechaFinalModel || this.fechaFinalModel == null || (this.fechaFinalModel && this.fechaFinalModel === 0)) {
			this.servicioAlerta.advertencia('Las Fechas son obligatorias');
			return;
		}
		if ((this.fechaInicioModel !== null && this.fechaFinalModel !== null) && (this.fechaInicioModel > this.fechaFinalModel)) {
			this.servicioAlerta.advertencia('La Fecha de inicio no puede ser mayor a la Fecha final');
			return;
		}
		if (this.usuarioMixto) {
			form.nombreUsuario = this.myUsuario.nombreusuario;
		}

		const estadpo_find = form.estado.trimEnd();

		this.consultarActividades(this.tipoFechaModel, this.zonaTrabajo, form.nombre,
			estadpo_find, form.nombreUsuario, this.idEmpresa, this.fechaService.cambioFormatoHora(this.fechaInicioModel),
			this.fechaService.cambioFormatoHora(this.fechaFinalModel), form.ubicacion);
	}


	validarFormularioReporte(form: any) {
		if (!this.fechaInicioModel || this.fechaInicioModel == null || (this.fechaInicioModel && this.fechaInicioModel.length === 0)
			|| !this.fechaFinalModel || this.fechaFinalModel == null || (this.fechaFinalModel && this.fechaFinalModel === 0)) {
			this.servicioAlerta.advertencia('Las Fechas son obligatorias');
			return;
		}
		if ((this.fechaInicioModel !== null && this.fechaFinalModel !== null) && (this.fechaInicioModel > this.fechaFinalModel)) {
			this.servicioAlerta.advertencia('La Fecha de inicio no puede ser mayor a la Fecha final');
			return;
		}

		const estadpo_find = form.estado.trimEnd();

		this.reporteActividades(this.tipoFechaModel, form.zonaTrabajo, form.nombre,
			estadpo_find, form.nombreUsuario, this.idEmpresa, this.fechaService.cambioFormatoHora(this.fechaInicioModel),
			this.fechaService.cambioFormatoHora(this.fechaFinalModel), form.ubicacion);
	}


	consultarActividades(tipoFecha: number, zona: string, nombre: string, estado: string,
		nombreUsuario: string, idCliente: number, fechaInicio: string, fechaFin: string, ubicacion: string) {
		this.servicioAlerta.limpiarMensajes();
		this.loading = true;
		setTimeout(() => {
			if (this.actividad.length === 0) {
				alert("Reduzca el tamaño de la consulta o mejore su velocidad de internet, por favor usar los filtros de ayuda para minimizar los tiempos de respuesta o realizar la búsqueda por el reporteador");
			}
		}, 40000);
		this.macroService.consultarActividades(ubicacion, tipoFecha, this.zonaTrabajo, nombre, estado, nombreUsuario,
			fechaInicio, fechaFin, idCliente).subscribe(
				data => {
					data.forEach((dx: any) => {
						let statusFound = this.estados.filter((obj) => dx.estado.toLowerCase() === obj.nombre.toLowerCase());
						if (statusFound.length > 0) {
							dx.estadoActividad = statusFound[0];
						} else {
							dx.estadoActividad = { color: "" };
						}
					});
					this.cargarDatosActividad(data);
					this.loading = false;
				}, (err) => {
					this.loading = false;
					if (err.name === "HttpErrorResponse") {
						this.servicioAlerta.advertencia("La consulta realizada posiblemente no es soportada por la velocidad de su internet, por favor usar los filtros de ayuda para minimizar los tiempos de respuesta o realizar la búsqueda por el reporteador");
						return;
					}
					this.controlarError(err);
				}
			);
	}

	consultarUsuariosPorClienteZona(idCliente: number, zonaTrabajo: number) {
		this.macroService.usuariosPorClienteZona(idCliente, zonaTrabajo).subscribe(
			data => {
				this.usuarios = data;
				this.usuariosBusqueda = data;
				this.zoom = 2;
				this.loading = false;
			}, error => {
				this.controlarError(error);
				this.loading = false;
			}
		);
	}

	visualizarMapa(mostrar) {
		this.mostrar = mostrar;
		this.cargarDatosActividad(this.actividad);
	}

	cargarDatosActividad(actividad: Actividad[]) {
		this.itemResource = new DataTableResource([]);
		this.reloadItems({ offset: 0, sortBy: 'fechaIngreso', sortAsc: false });
		if (actividad.length > 0) {
			this.zoom = 13;
			this.lat = actividad[actividad.length - 1].lat;
			this.lng = actividad[actividad.length - 1].alt; // cambiar por lng
			this.actividad = actividad;
			if (this.itemResource) {
				this.itemResource = new DataTableResource(actividad);
				this.reloadItems({ offset: 0, sortBy: 'fechaIngreso', sortAsc: false });
			} else {
				this.itemResource = new DataTableResource(actividad);
				this.reloadItems({ offset: 0, limit: 10, sortBy: 'fechaIngreso', sortAsc: false });
			}

		} else {
			this.zoom = 15;
			this.actividad = [];
			this.itemResource = new DataTableResource([]);
			this.reloadItems(this.itemResource);
			this.servicioAlerta.advertencia('La busqueda no trajo ningún resultado');
		}
	}

	ejecucionUsuarioCRM() {
		if (this.crm) {
			this.crud = true;
			this.loading = true;
			this.macroService.consultaEmpresasCrm(this.storage.get('nmus')).subscribe(
				data => {
					this.empresas = data;
					this.empresasBusqueda = JSON.parse(JSON.stringify(data));
					this.loading = false;
				}, err => {
					this.controlarError(err);
					this.loading = false;
				}
			);
		}
	}

	consultarEmpresas() {
		this.loading = true;
		this.macroService.empresas().subscribe(
			data => {
				const idsAsociados = this.myUsuario.empresasasociadas
					.split(',')
					.map(id => id.trim())
					.filter(id => id !== '');
				this.empresasBusqueda = this.empresas = data.filter(empresa => idsAsociados.includes(empresa.idempresa.toString()));				 
				this.loading = false;
			}, err => {
				this.controlarError(err);
				this.loading = false;
			}
		);
	}

	consultarUsuariosPorCliente(idCliente: number) {
		if (idCliente !== undefined && idCliente !== null) {
			this.loading = true;
			if (this.usuarioGregario) {
				this.macroService.usuariosPorClienteZona(idCliente, this.myUsuario.zonaTrabajo).subscribe(
					data => {
						data = data.filter(user => user.fechabaja === null);
						this.usuarios = data;
						this.usuariosBusqueda = data;
						this.zoom = 2;
						this.loading = false;
					}, error => {
						this.controlarError(error);
						this.loading = false;
					}
				);
			}
			this.usuarioinvitado = this.storage.get("uinvi") === "true";
			if (this.usuarioinvitado) {
				this.macroService.usuariosPorClienteZona(idCliente, this.myUsuario.zonaTrabajo).subscribe(
					data => {
						data = data.filter(user => user.fechabaja === null);
						this.usuarios = data;
						this.usuariosBusqueda = data;
						this.zoom = 2;
						this.loading = false;
					}, error => {
						this.controlarError(error);
						this.loading = false;
					}
				);
			} else {
				this.macroService.usuariosPorCliente(idCliente).subscribe(
					data => {
						this.usuarios = data;
						this.usuariosBusqueda = data;
						this.zoom = 2;
						this.loading = false;
					}, err => {
						this.controlarError(err);
						this.loading = false;
					}
				);
			}
		}
	}

	consultarEstadosPorCliente(idCliente: number) {
		if (idCliente !== undefined && idCliente !== null) {
			this.loading = true;
			this.macroService.estadosPorCliente(idCliente).subscribe(
				data => {
					this.estados = data;
					this.estadosBusqueda = data;
					this.loading = false;
				}, err => {
					this.controlarError(err);
					this.loading = false;
				}
			);
		}
	}

	getColorTarea(item: any) {
		let campoColors = this.estados.filter((colors) => colors.idestado === item.idEstadoTarea);
		if (campoColors.length === 1) {
			return campoColors[0].color;
		}
	}

	getIdColorTarea(nombre: String) {
		let campoColors = this.estados.filter((colors) => colors.nombre === nombre);
		if (campoColors.length > 0) {
			return campoColors[0].idestado;
		}
	}

	getEstadoActividadColorTarea(nombre: String) {
		let campoColors = this.estados.filter((colors) => colors.nombre === nombre);
		if (campoColors.length > 0) {
			return campoColors[0];
		}
	}

	consultarUbicacionesPorCliente(idCliente: number) {
		if (idCliente !== undefined && idCliente !== null) {
			this.loading = true;
			this.macroService.ubicacionesPorCliente(idCliente).subscribe(
				data => {
					this.ubicaciones = data.filter(obj => obj.fechabaja === null);
					this.ubicacionesBusqueda = data.filter(obj => obj.fechabaja === null);
					this.loading = false;
				}, err => {
					this.controlarError(err);
					this.loading = false;
				}
			);
		}
	}

	consultarUbicacionesPorClienteZona(idCliente: number, idzona: number) {
		if (idCliente !== undefined && idCliente !== null) {
			this.loading = true;
			this.macroService.ubicacionesPorClienteZona(idCliente, idzona).subscribe(
				data => {
					this.ubicaciones = data.filter(obj => obj.fechabaja === null);
					this.loading = false;
				}, err => {
					this.controlarError(err);
					this.loading = false;
				}
			);
		}
	}

	consultarZonasPorCliente(idCliente: number) {
		if (idCliente !== undefined && idCliente !== null && !this.usuarioinvitado) {
			this.loading = true;
			this.macroService.zonasPorCliente(idCliente).subscribe(
				data => {
					data = data.filter(zona => zona.fechaBaja === null || zona.fechaBaja === undefined);
					this.zonas = data;
					this.zonasBusqueda = data;
					this.loading = false;
				}, err => {
					this.controlarError(err);
					this.loading = false;
				}
			);
		} else {
			this.loading = true;
			this.macroService.consultarZonasSecundariasUsuario(this.myUsuario.idusuario).subscribe(
				data => {
					data = data.filter(zona => zona.fechaBaja === null || zona.fechaBaja === undefined);
					this.zonas = data;
					this.zonasBusqueda = data;
					this.loading = false;
				}, err => {
					this.controlarError(err);
					this.loading = false;
				}
			);
		}
	}

	consultarFormulariosPorCliente(idCliente: number) {
		if (idCliente !== undefined && idCliente !== null) {
			this.loading = true;
			this.macroService.formulariosPorCliente(idCliente).subscribe(
				data => {
					const forms = data.filter(form => form.formularioWeb === true);
					this.formularios = forms;
					this.formulariosBusqueda = forms;
					this.loading = false;
				}, err => {
					this.controlarError(err);
					this.loading = false;
				}
			);
		}
	}

	consultarFormulariosPorUsuario(idUsuario) {
		if (idUsuario !== undefined && idUsuario !== null) {
			this.loading = true;
			this.macroService.formulariosUsuario(idUsuario).subscribe(
				data => {
					if (this.usuarioGregario) {
						this.formularios = JSON.parse(JSON.stringify(data));
						this.formulariosBusqueda = JSON.parse(JSON.stringify(data));
					}
					this.usuarioinvitado = this.storage.get("uinvi") === "true";
					if (this.usuarioinvitado) {
						data.forEach(element => {
							let formFound = this.formularios.find((form) => form.nombreformulario === element.nombreformulario);
							if (!formFound) {
								this.formularios.push(element);
								this.formulariosBusqueda.push(element);
							}
						});
					} else {
						this.formularios = data;
						this.formulariosBusqueda = data;
					}
					this.loading = false;
				}, err => {
					this.controlarError(err);
					this.loading = false;
				}
			);
		}
	}

	reloadItems(params) {
		this.itemResource.query(params).then(items => this.items = items);
		this.itemResource.count().then(count => this.itemCount = count);
	}

	rowClick(rowEvent) { }

	rowDoubleClick(rowEvent) {
		this.usuarioinvitado = this.storage.get("uinvi") === "true";
		if (this.usuarioinvitado) {
			this.macroService.formularioId(rowEvent.row.item.id).subscribe(
				(response) => {
					this.formularioActividadSeleccionada = response;
					this.historicoEstadosActividad = [];
					this.cargarHistorialEstadoActividad(rowEvent.row.item.id);
					this.modalRef = this.modalService.show(this.modalhistorico, { class: 'modal-lg', backdrop: 'static' });
				}
			);
		} else {
			this.acoplamientoHorasMinutos();
			this.macroService.formularioId(rowEvent.row.item.id).subscribe( // este servicio trae la data de la actividad
				data => {
					this.actividadSeleccionada = data; // aqui se carga la data de la actividad seleccionada
					this.macroService.formulariosPorId(data.identificador).subscribe( // este servicio trae el formulario de la actividad
						(response) => {
							this.formularioActividadSeleccionada = response;
							this.estadosActividadFormularioActividadSeleccionada = this.formularioActividadSeleccionada.estadoActividadSeleccionado ?
								this.formularioActividadSeleccionada.estadoActividadSeleccionado.map((data) => {
									return JSON.parse(data);
								}) : [];
						}
					);
					if (this.actividadSeleccionada.idTarea && this.actividadSeleccionada.idTarea !== null && this.actividadSeleccionada.idTarea.length > 0) {
						this.macroService.obtenerTareaId(this.actividadSeleccionada.idTarea).subscribe(data => {
							this.tareaCrearActualizar = data;
						});
					} else {
						this.tareaCrearActualizar = {};
					}
					this.paginas = this.actividadSeleccionada.paginas;
					if (this.paginas.length > 0) {
						this.numerosPagina = Array.from({ length: this.paginas.length }, (x, i) => i);
						this.paginaActual = 0;
						this.informacionPagina = this.paginas[this.paginaActual];
						this.cantidadElementos = Array.from({ length: this.actividadSeleccionada.paginas[this.paginaActual].elementos.length }, (x, i) => i);
					}
					let statusFound = this.estados.filter((obj) => this.actividadSeleccionada.estado.toLowerCase() === obj.nombre.toLowerCase());
					if (statusFound.length > 0) {
						this.actividadSeleccionada.estadoActividad = statusFound[0];
					} else {
						this.actividadSeleccionada.estadoActividad = { color: "" };
					}
					//Carga datos de la lista en un MD
					for (let pagina of this.actividadSeleccionada.paginas) {
						for (let elemento of pagina.elementos) {
							if (elemento.identificador === "masterDetails") {
								if (elemento.filasMaestroDetalle !== undefined) {
									for (let filaMaestro of elemento.filasMaestroDetalle) {
										for (let elementoFila of filaMaestro.elementos) {
											if (elementoFila.identificador === "selectList") {
												for (let elementoRepetitivo of elemento.plantilla.elementosRepetitivos) {
													if (elementoFila.label === elementoRepetitivo.label) {
														elementoFila.opciones = elementoRepetitivo.opciones;
														break;
													}
												}
											}
										}
									}
								}
							}
						}
					}
					// this.cargarHistorialTarea();
					// this.cargarHistorialActividad();
					// this.verHistoricoActividad = false;
					// this.getHistoricoActividad(this.actividadSeleccionada);
					this.nuevaActividad = false;
					this.editarActividad = false;
					this.modalRef = this.modalService.show(this.viewrActivity, { class: 'modal-lg', backdrop: 'static' });
				}, err => {
					this.controlarError(err);
					this.loading = false;
				}
			);
		}
	}

	paginaNumerada(pagina: number) {
		this.paginaActual = pagina;
		this.informacionPagina = this.paginas[this.paginaActual];
		this.cantidadElementos = Array.from({ length: this.actividadSeleccionada.paginas[this.paginaActual].elementos.length }, (x, i) => i);
		this.numeroPaginaSelccionada = pagina + '';
	}

	paginaSiguiente() {
		if ((this.paginaActual + 1) < this.numerosPagina.length) {
			this.paginaActual++;
			this.informacionPagina = this.paginas[this.paginaActual];
			this.cantidadElementos = Array.from({ length: this.actividadSeleccionada.paginas[this.paginaActual].elementos.length }, (x, i) => i);
		}
	}

	paginaAnterior() {
		if (this.paginaActual > 0) {
			this.paginaActual--;
			this.informacionPagina = this.paginas[this.paginaActual];
			this.cantidadElementos = Array.from({ length: this.actividadSeleccionada.paginas[this.paginaActual].elementos.length }, (x, i) => i);
		}
	}

	rowTooltip(item) { return item.nombre; }

	controlarError(error: any) {
		this.servicioAlerta.error(error);
	}

	reporteActividades(tipoFecha: number, zona: string, nombre: string, estado: string,
		nombreUsuario: string, idCliente: number, fechaInicio: string, fechaFin: string, ubicacion: string) {
		this.servicioAlerta.limpiarMensajes();
		this.loading = true;
		this.macroService.reporteActividades(ubicacion, tipoFecha, zona, nombre, estado, nombreUsuario,
			fechaInicio, fechaFin, idCliente).subscribe(
				data => {
					const filename = "reporte.xls";
					FileSaver.saveAs(data, filename);
					this.loading = false;
				}, err => {
					this.loading = false;
					this.controlarError(err);
				}
			);
	}

	generarPdfActividad(idactividad) {
		if (this.usuarioinvitado) {
			return;
		}
		this.servicioAlerta.limpiarMensajes();
		this.loading = true;
		this.macroService.reportePdfActividad(idactividad).subscribe(
			data => {
				const filename = "actividad.pdf";
				FileSaver.saveAs(data, filename);
				this.loading = false;
			}, err => {
				this.loading = false;
				this.controlarError(err);
			}
		);
	}

	seleccionaPaginaNumerada() {
		this.paginaNumerada(parseInt(this.numeroPaginaSelccionada));
		this.cantidadElementos = Array.from({ length: this.actividadSeleccionada.paginas[this.paginaActual].elementos.length }, (x, i) => i);
	}

	convertirArreglo(arreglo) {
		if (arreglo) {
			return Array.from({ length: arreglo.length }, (x, i) => i);
		} else {
			return []
		}
	}

	onFileChanged(event) {
		this.fileVerication = event.target.files[0];

		const fileType = this.fileVerication.type.split('/')[0]; // obtiene el tipo de archivo (image, video, etc.)

		// verifica el tamaño del archivo según el tipo
		switch (fileType) {
			case 'image':
				this.fileSizeError = this.fileVerication.size > this.maxImageFileSizeInMB * 1024 * 1024;
				break;
			case 'video':
				this.fileSizeError = this.fileVerication.size > this.maxVideoFileSizeInMB * 1024 * 1024;
				break;
			default:
				// manejo para otros tipos de archivos, si es necesario
				break;
		}

		if (this.fileSizeError) {
			alert('El limite de tamaño para video es de 5MB y para fotos 1MB !!!');
		} else {
			this.selectedFile = this.fileVerication;
		}
	}

	botonActive(paginaActual, elementosCount) {
		this.paginab = paginaActual;
		this.elementob = elementosCount;
	}

	botonActiveMaestro(paginaActual, elementosCount, maestroDetalleCount, elementoMaestroCount) {
		this.paginab = paginaActual;
		this.elementob = elementosCount;
		this.maestrob = maestroDetalleCount;
		this.elementoMaestrob = elementoMaestroCount;
	}

	onUploadImagenNewActivity(paginaActual, indexElemento) {
		this.cargaFirmaNewActiviy = true;
		const uploadData = new FormData();
		uploadData.append('file', this.selectedFile, this.selectedFile.name);
		var time = new Date().getTime()
		this.macroService.uploadFileMA(uploadData, this.idEmpresa + "-" + time).subscribe(() => {
			var url = this.macroFiles + "images/" + this.idEmpresa + "-" + time + ".png"
			this.formularioToNewActivity === undefined ? this.actividadSeleccionada.paginas[paginaActual].elementos[indexElemento].url = url : this.formularioToNewActivity.paginas[paginaActual].elementos[indexElemento].url = url;
			this.cargaFirmaNewActiviy = false;
			this.selectedFile = undefined;
		}, error => {
			this.cargaFirmaNewActiviy = false;
		});
	}

	onUploadImagen(paginaActual, elementosCount) {
		this.loading = true;
		const uploadData = new FormData();
		uploadData.append('file', this.selectedFile, this.selectedFile.name);
		var time = new Date().getTime();
		this.macroService.uploadFileMA(uploadData, this.idEmpresa + "-" + time).subscribe(() => {
			var url = this.macroFiles + "images/" + this.idEmpresa + "-" + time + ".png"
			this.formularioToNewActivity === undefined ? this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].url = url : this.formularioToNewActivity.paginas[paginaActual].elementos[elementosCount].url = url;
			this.loading = false;
			this.selectedFile = undefined;
		}, error => {
			this.loading = false;
		});
	}

	onUploadImagenMaster(paginaActual, elementosCount, maestroDetalleCount, elementoMaestroCount) {
		this.loading = true;
		const uploadData = new FormData();
		uploadData.append('file', this.selectedFile, this.selectedFile.name);
		var time = new Date().getTime()
		this.macroService.uploadFileMA(uploadData, this.idEmpresa + "-" + time).subscribe(() => {
			var url = this.macroFiles + "images/" + this.idEmpresa + "-" + time + ".png"
			this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle[maestroDetalleCount].elementos[elementoMaestroCount].url = url;
			this.loading = false;
			this.selectedFile = undefined;
		}, error => {
			this.loading = false;
		});
	}

	onUploadImagenPicture(paginaActual, elementosCount) {
		this.loading = true;
		const uploadData = new FormData();
		uploadData.append('file', this.selectedFile, this.selectedFile.name);
		var time = new Date().getTime()
		this.macroService.uploadFileMA(uploadData, this.idEmpresa + "-" + time).subscribe(() => {
			var url = this.macroFiles + "images/" + this.idEmpresa + "-" + time + ".png"
			this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].valorDiligenciado = url;
			this.loading = false;
			this.selectedFile = undefined;
		}, error => {
			this.loading = false;
		});
	}

	onUploadImagenFirma(paginaActual, elementosCount) {
		this.loading = true;
		const uploadData = new FormData();
		uploadData.append('file', this.selectedFile, this.selectedFile.name);
		var time = new Date().getTime()
		this.macroService.uploadFileMA(uploadData, this.idEmpresa + "-" + time).subscribe(() => {
			var url = this.macroFiles + "images/" + this.idEmpresa + "-" + time + ".png"
			this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].url = url;
			this.loading = false;
			this.selectedFile = undefined;
		}, error => {
			this.loading = false;
		});
	}

	onUploadVideo(paginaActual, elementosCount) {
		this.loading = true;
		const uploadData = new FormData();
		uploadData.append('file', this.selectedFile, this.selectedFile.name);
		var time = new Date().getTime()
		this.macroService.uploadFileMA(uploadData, "videos-" + this.idEmpresa + "-" + time + "-mp4").subscribe((response) => {
			var url = this.macroFiles + "videos/" + this.idEmpresa + "-" + time + ".mp4"
			this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].valorDiligenciado = url;
			this.loading = false;
			this.selectedFile = undefined;
		}, error => {
			this.loading = false;
		});
	}

	onUploadImagenPictureMaster(paginaActual, elementosCount, maestroDetalleCount, elementoMaestroCount) {
		this.loading = true;
		const uploadData = new FormData();
		uploadData.append('file', this.selectedFile, this.selectedFile.name);
		var time = new Date().getTime()
		this.macroService.uploadFileMA(uploadData, this.idEmpresa + "-" + time).subscribe(() => {
			var url = this.macroFiles + "images/" + this.idEmpresa + "-" + time + ".png"
			this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle[maestroDetalleCount].elementos[elementoMaestroCount].valorDiligenciado = url;
			this.loading = false;
			this.selectedFile = undefined;
		}, error => {
			this.loading = false;
		});
	}

	onUploadVideoMaster(paginaActual, elementosCount, maestroDetalleCount, elementoMaestroCount) {
		this.loading = true;
		const uploadData = new FormData();
		uploadData.append('file', this.selectedFile, this.selectedFile.name);
		var time = new Date().getTime()
		this.macroService.uploadFileMA(uploadData, "videos-" + this.idEmpresa + "-" + time + "-mp4").subscribe(() => {
			var url = this.macroFiles + "videos/" + this.idEmpresa + "-" + time + ".mp4"
			this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle[maestroDetalleCount].elementos[elementoMaestroCount].valorDiligenciado = url;
			this.loading = false;
			this.selectedFile = undefined;
		}, error => {
			this.loading = false;
		});
	}

	guardarInputMaestro(paginaActual: number, elementosCount: number, maestroDetalleCount: number, elementoMaestroCount: number, nuevoValor: string) {
		// metodo creado por que existen elementos con campos definidos y ngmodel no permite el uso opcion de value
		this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle[maestroDetalleCount].elementos[elementoMaestroCount].valorDiligenciado = nuevoValor;
	}

	guardarInputElemento(paginaActual: number, elementosCount: number, nuevoValor: string) {
		// metodo creado por que existen elementos con campos definidos y ngmodel no permite el uso opcion de value
		this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].valorDiligenciado = nuevoValor;
	}

	guardarUbicacionAsociada(event: Event) {
		if (this.actividadSeleccionada.paginas[0].elementos[0].tipo !== 'LocationForm') {
			this.actividadSeleccionada.paginas[0].elementos.unshift({});
		}

		const valorSeleccionado = (event.target as HTMLSelectElement).value;

		if (valorSeleccionado !== '') {
			this.actividadSeleccionada.paginas[0].elementos[0].orden = 0;
			this.actividadSeleccionada.paginas[0].elementos[0].asociadoUbicacion = false;
			this.actividadSeleccionada.paginas[0].elementos[0].ubicacionCondicional = false;
			this.actividadSeleccionada.paginas[0].elementos[0].tipo = 'LocationForm';
			this.actividadSeleccionada.paginas[0].elementos[0].identificador = 'LocationForm';
			this.actividadSeleccionada.paginas[0].elementos[0].descriptivo = false;
			this.actividadSeleccionada.paginas[0].elementos[0].bloqueado = false;
			this.actividadSeleccionada.paginas[0].elementos[0].esSoloLectura = false;
			this.actividadSeleccionada.paginas[0].elementos[0].esRequerido = false;
			this.actividadSeleccionada.paginas[0].elementos[0].valorDiligenciado = valorSeleccionado;
			this.actividadSeleccionada.ubicacion = valorSeleccionado.split(',')[1].replace(/^\s+/, '');
			this.ubicacionAsociadaG = valorSeleccionado.split(',')[0];
			for (let i = 0; i < this.actividadSeleccionada.paginas.length; i++) {
				if (this.actividadSeleccionada.paginas[0].elementos[0].tipo == 'LocationForm') {
					this.actividadSeleccionada.paginas[i].editable = true;
					this.actividadSeleccionada.paginas[i].idUbicacion = this.ubicacionAsociadaG;
					this.actividadSeleccionada.paginas[i].numero = i;
					this.actividadSeleccionada.paginas[i].tieneLocation = true;
				}
			}
			this.recorrerActividadSeleccionada();
		}
	}

	guardarFinalizado() {
		this.validarCamposRequeridos('Finalizado');
	}

	validarCamposRequeridos(estadoDestino: string = 'Finalizado'): void {
		this.camposRequeridosVacios = this.recolectarObligatoriosVacios();

		if (this.camposRequeridosVacios.length > 0) {
			this.modalRef = this.modalService.show(this.modalCamposRequeridos, { class: 'modal-md', backdrop: 'static' });
		} else {
			this.continuarGuardado(estadoDestino);
		}
	}

	// Recolecta, sin efectos secundarios (no toca this.camposRequeridosVacios ni abre modales), los
	// nombres de los campos obligatorios vacios. La usa validarCamposRequeridos() para decidir si
	// abrir el modal, y obligatoriosCompletos() para la revalidacion silenciosa del cronometro.
	private recolectarObligatoriosVacios(): string[] {
		const vacios: string[] = [];

		if (!this.actividadSeleccionada || !this.actividadSeleccionada.paginas) {
			return vacios;
		}

		for (let i = 0; i < this.actividadSeleccionada.paginas.length; i++) {
			const pagina = this.actividadSeleccionada.paginas[i];

			for (let j = 0; j < pagina.elementos.length; j++) {
				const elemento = pagina.elementos[j];

				if (elemento.esRequerido && elemento.visible !== false) {
					this.validarElementoRequerido(elemento, `Página ${i + 1}`, vacios);
				}

				if (elemento.tipo === 'masterDetails' && elemento.filasMaestroDetalle) {
					this.validarMaestroDetalle(elemento, i + 1, vacios);
				}
			}
		}

		return vacios;
	}

	// true si no falta ningun campo obligatorio; usada por el cronometro para saber cuando puede
	// finalizar automaticamente sin mostrar el modal de campos requeridos.
	obligatoriosCompletos(): boolean {
		return this.recolectarObligatoriosVacios().length === 0;
	}

	// ==================== CRONOMETRO AUTOMATICO DEL FORMULARIO ====================
	// Si la plantilla trae un elemento de tipo "cronometro" arranca un conteo regresivo flotante.
	// Al vencerse guarda automaticamente y, si faltan obligatorios, bloquea los demas campos hasta
	// que se completen (ver alVencerCronometro()).

	private obtenerElementoCronometro(): any {
		if (!this.actividadSeleccionada || !this.actividadSeleccionada.paginas) {
			return null;
		}
		for (const pagina of this.actividadSeleccionada.paginas) {
			if (!pagina.elementos) { continue; }
			for (const elemento of pagina.elementos) {
				const identificador = (elemento.identificador || '').toString().toUpperCase();
				const tipo = (elemento.tipo || '').toString().toUpperCase();
				if ((identificador === 'CRONOMETRO' || tipo === 'CRONOMETRO') && elemento.tiempoEspera > 0) {
					return elemento;
				}
			}
		}
		return null;
	}

	iniciarCronometro(): void {
		this.detenerCronometro();
		const elementoCronometro = this.obtenerElementoCronometro();
		if (!elementoCronometro) {
			this.cronometroVisible = false;
			return;
		}
		this.cronometroDeadline = Date.now() + elementoCronometro.tiempoEspera * 1000;
		this.cronometroVencido = false;
		this.cronometroCritico = false;
		this.cronometroVisible = true;
		const accion = elementoCronometro.accionDuranteCronometro;
		this.actualizarTextoCronometro(accion);
		this.cronometroTick = setInterval(() => this.tickCronometro(accion), 1000);
	}

	private tickCronometro(accion: string): void {
		const restanteMs = this.cronometroDeadline - Date.now();
		if (restanteMs <= 0) {
			this.alVencerCronometro();
			return;
		}
		this.actualizarTextoCronometro(accion, restanteMs);
	}

	private actualizarTextoCronometro(accion: string, restanteMs?: number): void {
		const totalMs = restanteMs !== undefined ? restanteMs : this.cronometroDeadline - Date.now();
		const segundosRestantes = Math.max(0, Math.ceil(totalMs / 1000));
		const minutos = Math.floor(segundosRestantes / 60);
		const segundos = segundosRestantes % 60;
		const tiempo = `⏱ ${minutos.toString().padStart(2, '0')}:${segundos.toString().padStart(2, '0')}`;
		this.cronometroTexto = accion ? `${accion} · ${tiempo}` : tiempo;
		this.cronometroCritico = segundosRestantes <= 30;
	}

	detenerCronometro(): void {
		if (this.cronometroTick) { clearInterval(this.cronometroTick); this.cronometroTick = null; }
		if (this.cronometroRevalidacion) { clearInterval(this.cronometroRevalidacion); this.cronometroRevalidacion = null; }
		this.cronometroVisible = false;
		this.cronometroVencido = false;
		this.cronometroCritico = false;
	}

	// Deshabilita en el template los elementos no obligatorios una vez vencido el cronometro.
	bloqueadoPorCronometro(elemento: any): boolean {
		return this.cronometroVencido && !(elemento && elemento.esRequerido);
	}

	// dateTime/time/date con valorDefecto 'CURRENTDATE' se autocompletan solos en
	// recorrerActividadSeleccionada(); no cuentan como diligenciados por el usuario.
	private esAutoLlenadoPorDefecto(elemento: any): boolean {
		return (elemento.tipo === 'dateTime' || elemento.tipo === 'time' || elemento.tipo === 'date')
			&& elemento.valorDefecto === 'CURRENTDATE';
	}

	private elementoRequiereDiligenciamiento(elemento: any): boolean {
		const tipo = (elemento.tipo || '').toString().toUpperCase();
		const tiposNoDiligenciables = ['TITULO', 'CALCULADORA', 'CONSECUTIVO', 'LOCATIONFORM'];
		return !elemento.esSoloLectura
			&& tiposNoDiligenciables.indexOf(tipo) === -1
			&& !this.esAutoLlenadoPorDefecto(elemento);
	}

	// true si el usuario no diligencio ningun campo, ignorando lo que la plantilla llena sola
	// (fechas CURRENTDATE, elementos de solo lectura o no diligenciables como titulo/calculadora/etc.).
	private formularioSinDiligenciar(): boolean {
		if (!this.actividadSeleccionada || !this.actividadSeleccionada.paginas) {
			return true;
		}
		for (const pagina of this.actividadSeleccionada.paginas) {
			if (!pagina.elementos) { continue; }
			for (const elemento of pagina.elementos) {
				if (this.elementoRequiereDiligenciamiento(elemento) && !this.estaVacio(elemento.valorDiligenciado)) {
					return false;
				}
				if (elemento.tipo === 'masterDetails' && elemento.filasMaestroDetalle && elemento.filasMaestroDetalle.length > 0) {
					for (const fila of elemento.filasMaestroDetalle) {
						if (!fila.elementos) { continue; }
						for (const elementoInterno of fila.elementos) {
							if (this.elementoRequiereDiligenciamiento(elementoInterno) && !this.estaVacio(elementoInterno.valorDiligenciado)) {
								return false;
							}
						}
					}
				}
			}
		}
		return true;
	}

	private alVencerCronometro(): void {
		clearInterval(this.cronometroTick);
		this.cronometroTick = null;
		this.cronometroVencido = true;
		this.cronometroTexto = 'Tiempo vencido';
		this.cronometroCritico = true;

		if (this.formularioSinDiligenciar()) {
			this.servicioAlerta.advertencia('Se agotó el tiempo y no se diligenció ningún campo. Se cancela la actividad.');
			this.detenerCronometro();
			this.cancelarCreacion(this.actividadSeleccionada.id);
			return;
		}
		if (this.obligatoriosCompletos()) {
			this.detenerCronometro();
			this.guardarFinalizado();
			return;
		}
		this.servicioAlerta.advertencia('Tiempo vencido. Solo puede completar los campos obligatorios para finalizar.');
		this.cronometroUltimaActividad = Date.now();
		this.cronometroRevalidacion = setInterval(() => {
			const sinActividadReciente = (Date.now() - this.cronometroUltimaActividad) >= PorFormularioComponent.CRONOMETRO_DEBOUNCE_MS;
			if (sinActividadReciente && this.obligatoriosCompletos()) {
				this.detenerCronometro();
				this.guardarFinalizado();
			}
		}, 2000);
	}

	// Enganchado a (input)/(change) en el formulario (ver HTML): marca que el usuario sigue
	// escribiendo, para que la revalidacion del cronometro no finalice a mitad de una palabra.
	marcarActividadCronometro(): void {
		if (this.cronometroVencido) {
			this.cronometroUltimaActividad = Date.now();
		}
	}

	continuarGuardado(estadoDestino: string): void {
		this.detenerCronometro();
		if (this.modalRef) {
			this.modalRef.hide();
		}
		this.actividadSeleccionada.estado = estadoDestino;

		if (this.esPqrFormulario() && estadoDestino === 'Finalizado') {
			this.crearPqrDesdeFormulario();
		} else {
			this.actualizarActividad();
		}
	}

	cancelarGuardado(): void {
		if (this.modalRef) {
			this.modalRef.hide();
		}
	}

	private esPqrFormulario(): boolean {
		const nombre = this.formularioToNewActivity
			? this.formularioToNewActivity.nombre
			: (this.actividadSeleccionada ? this.actividadSeleccionada.nombre : null);
		return nombre && nombre.toLowerCase().includes('pqr');
	}

	private crearPqrDesdeFormulario(): void {
		this.loading = true;
		this.guardandoActividad = true;
		this.recorrerActividadSeleccionada();

		const pqr = this.construirObjetoPqr();
		this.macroService.crearPqr(pqr).subscribe(
			(response) => {
				this.servicioAlerta.exito('PQR creada exitosamente');
				this.eliminarActividadYResetear();
			},
			(error) => {
				if (error.status === 200 || error.status === 201) {
					this.servicioAlerta.exito('PQR creada exitosamente');
					this.eliminarActividadYResetear();
				} else {
					this.servicioAlerta.errorMensaje('Error creando la PQR');
					this.loading = false;
					this.guardandoActividad = false;
				}
			}
		);
	}

	private eliminarActividadYResetear(): void {
		if (this.actividadSeleccionada && this.actividadSeleccionada.id) {
			this.macroService.elimiarActividades([this.actividadSeleccionada.id]).subscribe(
				() => this.resetearEstadoPqr(),
				() => this.resetearEstadoPqr()
			);
		} else {
			this.resetearEstadoPqr();
		}
	}

	private resetearEstadoPqr(): void {
		this.guardandoActividad = false;
		this.editarActividad = false;
		this.historialesActividad = false;
		this.verHistoricoActividad = false;
		this.redireccionarActividad = false;
		this.nuevaActividad = false;
		this.historicoActividad = [];
		this.historicoEstadosActividad = [];
		this.historicoTarea = [];
		this.loading = false;
		this.campoBusquedaFormulario = '';
		this.formulariosBusqueda = this.formularios;
		this.formularioToNewActivity = undefined;
	}

	private construirObjetoPqr(): any {
		const empresaActual = this.empresas
			? this.empresas.find(e => e.idempresa && e.idempresa.toString() === this.idEmpresa.toString())
			: null;

		const datosExtraidos = this.extraerDatosFormularioPqr();

		return {
			idEmpresa: this.idEmpresa,
			nombreEmpresa: empresaActual ? empresaActual.nombre : '',
			idUsuario: this.storage.get('nmus'),
			nombreUsuario: this.storage.get('nomus'),
			asunto: 'Formulario - ' + (this.formularioToNewActivity ? this.formularioToNewActivity.nombre : (this.actividadSeleccionada ? this.actividadSeleccionada.nombre : '')),
			fechaReporte: new Date(),
			descripcion: datosExtraidos.descripcion,
			telefono: datosExtraidos.telefono,
			correo: datosExtraidos.correo,
			estado: 'pendiente',
			mensajes: ''
		};
	}

	private extraerDatosFormularioPqr(): { descripcion: string, telefono: string, correo: string } {
		let descripcion = '';
		let telefono = '';
		let correo = '';

		if (!this.actividadSeleccionada || !this.actividadSeleccionada.paginas) {
			return { descripcion, telefono, correo };
		}

		for (let i = 0; i < this.actividadSeleccionada.paginas.length; i++) {
			const pagina = this.actividadSeleccionada.paginas[i];
			if (!pagina.elementos) continue;

			for (let j = 0; j < pagina.elementos.length; j++) {
				const elemento = pagina.elementos[j];
				const label = elemento.label || elemento.identificador || 'Campo';
				const valor = elemento.valorDiligenciado || '';
				const labelLower = label.toLowerCase();

				if (valor !== '') {
					descripcion += label + ': ' + valor + '\n';

					if (labelLower.includes('telefono') || labelLower.includes('teléfono') || labelLower.includes('celular')) {
						telefono = valor;
					}
					if (labelLower.includes('correo') || labelLower.includes('email') || labelLower.includes('e-mail')) {
						correo = valor;
					}
				}

				if (elemento.tipo === 'masterDetails' && elemento.filasMaestroDetalle) {
					for (let k = 0; k < elemento.filasMaestroDetalle.length; k++) {
						const fila = elemento.filasMaestroDetalle[k];
						if (fila.elementos) {
							for (let l = 0; l < fila.elementos.length; l++) {
								const elemInterno = fila.elementos[l];
								const labelInt = elemInterno.label || elemInterno.identificador || 'Campo';
								const valorInt = elemInterno.valorDiligenciado || '';
								const labelIntLower = labelInt.toLowerCase();

								if (valorInt !== '') {
									descripcion += '  ' + labelInt + ': ' + valorInt + '\n';

									if (labelIntLower.includes('telefono') || labelIntLower.includes('teléfono') || labelIntLower.includes('celular')) {
										telefono = valorInt;
									}
									if (labelIntLower.includes('correo') || labelIntLower.includes('email') || labelIntLower.includes('e-mail')) {
										correo = valorInt;
									}
								}
							}
						}
					}
				}
			}
		}

		return { descripcion: descripcion.trim(), telefono, correo };
	}

	private validarElementoRequerido(elemento: any, contexto: string, destino: string[]) {
		if (this.estaVacio(elemento.valorDiligenciado)) {
			const nombreCampo = elemento.label || elemento.identificador || 'Campo sin nombre';
			destino.push(`${nombreCampo} (${contexto})`);
		}
	}

	private validarMaestroDetalle(elementoMaestro: any, numeroPagina: number, destino: string[]) {
		if (!elementoMaestro.filasMaestroDetalle) return;

		for (let k = 0; k < elementoMaestro.filasMaestroDetalle.length; k++) {
			const fila = elementoMaestro.filasMaestroDetalle[k];

			if (fila.elementos) {
				for (let l = 0; l < fila.elementos.length; l++) {
					const elementoInterno = fila.elementos[l];

					if (elementoInterno.esRequerido && elementoInterno.visible !== false) {
						if (this.estaVacio(elementoInterno.valorDiligenciado)) {
							const nombreCampo = elementoInterno.label || elementoInterno.identificador || 'Campo sin nombre';
							const nombreMaestro = elementoMaestro.label || 'Maestro Detalle';
							destino.push(`${nombreCampo} (${nombreMaestro} - Fila ${k + 1}, Página ${numeroPagina})`);
						}
					}
				}
			}
		}
	}

	private estaVacio(valor: any): boolean {
		if (valor === null || valor === undefined) {
			return true;
		}
		
		if (typeof valor === 'string') {
			return valor.trim() === '';
		}
		
		if (Array.isArray(valor)) {
			return valor.length === 0;
		}
		
		return false;
	}

	guardarCompletado() {
		this.actividadSeleccionada.estado = "Completado";
		this.actualizarActividad();
	}

	actualizarActividad() {
		this.loading = true;
		this.actividadSeleccionada.estadoActividad = this.getEstadoActividadColorTarea(this.actividadSeleccionada.estadoTarea);
		this.actividadSeleccionada.idEstadoTarea = this.getIdColorTarea(this.actividadSeleccionada.estadoTarea);
		this.actividadSeleccionada.idEstadomovil = this.actividadSeleccionada.idEstadoTarea;
		this.guardandoActividad = true;
		this.recorrerActividadSeleccionada();
		this.macroService.actualizarActividad(this.actividadSeleccionada, this.storage.get("nomus")).subscribe(
			(response) => {
				this.servicioAlerta.exito('Actividad Guarda Exitosamente');
				this.guardandoActividad = false;
				this.editarActividad = false;
				this.historialesActividad = false;
				this.verHistoricoActividad = false;
				this.redireccionarActividad = false;
				this.nuevaActividad = false;
				this.historicoActividad = [];
				this.historicoEstadosActividad = [];
				this.historicoTarea = [];
				this.loading = false;				
			}, (error) => {
				if (error.status === 200) {
					this.servicioAlerta.exito('Actividad Guarda Exitosamente');
					this.editarActividad = false;
					this.guardandoActividad = false;
					this.historialesActividad = false;
					this.verHistoricoActividad = false;
					this.redireccionarActividad = false;
					this.nuevaActividad = false;
					this.historicoActividad = [];
					this.historicoEstadosActividad = [];
					this.historicoTarea = [];
				} else {
					this.editarActividad = false;
					this.guardandoActividad = false;
					this.historialesActividad = false;
					this.verHistoricoActividad = false;
					this.redireccionarActividad = false;
					this.nuevaActividad = false;
					this.historicoActividad = [];
					this.historicoEstadosActividad = [];
					this.historicoTarea = [];
					this.servicioAlerta.error('Error Guardando Actividad');
				}
				this.loading = false;
			});
		this.campoBusquedaFormulario = '';
		this.formulariosBusqueda = this.formularios;
		this.redireccionarActividad = false;
		this.editarActividad = false;
		this.formularioToNewActivity = undefined;
		this.historialesActividad = false;
	}

	redireccionarActividadUsuario() {
		if (this.actividadSeleccionada.idTarea === null || this.actividadSeleccionada.idTarea.length === 0) {
			this.tareaCrearActualizar.nombre = "Re Despacho Cloud"
			this.tareaCrearActualizar.identificadorformulario = this.actividadSeleccionada.identificador;
			this.tareaCrearActualizar.idFormularioMovil = this.actividadSeleccionada.identificador;
			this.tareaCrearActualizar.idformulariodiligenciado = this.actividadSeleccionada.id;
			this.tareaCrearActualizar.nombreformulario = this.actividadSeleccionada.nombre;
			this.tareaCrearActualizar.idempresa = this.actividadSeleccionada.idCliente;
			this.tareaCrearActualizar.jornada = "diurna y nocturna";
			this.tareaCrearActualizar.estadoTarea = "Redespachada";
			this.tareaCrearActualizar.idzonatrabajo = this.actividadSeleccionada.zonaTrabajo;
			this.tareaCrearActualizar.zonatrabajo = this.actividadSeleccionada.zonaTrabajoDescripcion;
			this.tareaCrearActualizar.tiporepeticion = "solo una vez";
			this.tareaCrearActualizar.multiUbicacion = true;
			// this.tareaCrearActualizar.id = this.actividadSeleccionada.idTarea;
		} else {
			this.tareaCrearActualizar.idTareapadre = this.actividadSeleccionada.idTarea;
			this.tareaCrearActualizar.idformulariodiligenciado = this.actividadSeleccionada.id;
		}
		// this.tareaCrearActualizar.recomendaciones = this.actividadSeleccionada.recomendacionesHoja === null || this.actividadSeleccionada.recomendacionesHoja === undefined ? [] : this.actividadSeleccionada.recomendacionesHoja;
		// alert("this.actividadSeleccionada.recomendacionesHoja " + this.actividadSeleccionada.recomendacionesHoja);
		// alert("this.actividadSeleccionada.recomendaciones" + this.actividadSeleccionada.recomendaciones);
		this.tareaCrearActualizar.recomendaciones = this.actividadSeleccionada.recomendaciones === null || this.actividadSeleccionada.recomendaciones === undefined ? [] : this.actividadSeleccionada.recomendaciones;
		if (this.usuarioMixto) {
			this.actividadSeleccionada.nombreUsuario = this.nombreUsuarioLog;
			this.actividadSeleccionada.idUsuario = this.idUsuarioLog;
		}
		let today = new Date();
		if (this.tareaCrearActualizar.fechainicio === '' || this.tareaCrearActualizar.fechainicio === null || this.tareaCrearActualizar.fechainicio === undefined) {
			alert('La fecha de inicio es requerida');
			return;
		}
		if (this.tareaCrearActualizar.fechafin === '' || this.tareaCrearActualizar.fechafin === null || this.tareaCrearActualizar.fechafin === undefined) {
			alert('La fecha fin es requerida');
			return;
		}
		let ini = this.dateFromString(this.tareaCrearActualizar.fechainicio, this.tareaCrearActualizar.horainicio, this.tareaCrearActualizar.minutoinicio);
		if (ini < today) {
			alert('La fecha y hora de inicio debe ser mayor a la fecha y hora actual.');
			return;
		}
		let end = this.dateFromString(this.tareaCrearActualizar.fechafin, this.tareaCrearActualizar.horafin, this.tareaCrearActualizar.minutofin);
		if (end < today) {
			alert('La fecha y hora fin debe ser mayor a la fecha y hora actual.');
			return;
		}
		if (ini > end) {
			alert('La fecha y hora fin debe ser mayor a la fecha y hora inicial.');
			return;
		}

		let difMonth = this.getDifMont(this.tareaCrearActualizar.fechafin, this.tareaCrearActualizar.fechainicio);
		if (difMonth > 61) {
			alert('No se puede crear tareas con más de DOS meses de diferencia.');
			return;
		}

		if (this.tareaCrearActualizar.tiempoAntesExpira && this.tareaCrearActualizar.tiempoAntesExpira < 0) {
			alert('El tiempo de notifiación antes del inicio de la tarea debe ser mayor o igual a cero.');
			return;
		}
		if (this.tareaCrearActualizar.tiempoDespuesExpira && this.tareaCrearActualizar.tiempoDespuesExpira < 0) {
			alert('Los minutos programados para después del fin de la tarea deben ser mayor o igual a cero.');
			return;
		}
		if (this.tareaCrearActualizar.tiempoEliminar && this.tareaCrearActualizar.tiempoEliminar < 0) {
			alert('Los Minutos para Eliminar deben ser mayor o igual a cero.');
			return;
		}
		if (this.tareaCrearActualizar.nombreUsuarios && this.tareaCrearActualizar.nombreUsuarios.length === 0) {
			alert('Debe Seleccionar por lo menos un usuario');
			return;
		}
		this.verificacionArrayTarea(this.tareaCrearActualizar);
		this.creacionActualizacionTarea(this.tareaCrearActualizar);
		this.modalRef.hide();
	}

	private verificacionArrayTarea(objeto: any) {
		if (!Array.isArray(objeto.idubicaciones)) {
			var idUbicacionAuxiliar = objeto.idubicaciones;
			objeto.idubicaciones = [];
			objeto.idubicaciones.push(idUbicacionAuxiliar);
		}
		if (this.actividadSeleccionada.nombreUsuario) {
			var nombreUsuarioAuxiliar = this.actividadSeleccionada.nombreUsuario;
			objeto.nombreUsuarios = [];
			if (nombreUsuarioAuxiliar && nombreUsuarioAuxiliar != null) {
				objeto.nombreUsuarios.push(nombreUsuarioAuxiliar);
			}
		}
	}

	private creacionActualizacionTarea(tarea) {
		tarea.fechainiciotarea = tarea.fechainicio;
		tarea.fechafintarea = tarea.fechafin;
		tarea.fechainicioTexto = tarea.fechainicio;
		tarea.fechafinTexto = tarea.fechafin;
		// tarea.nombreUbicacion = this.actividadSeleccionada.ubicacion; 
		tarea.hechoDesde = "Web";
		this.loading = true;
		this.macroService.actualizarCrearTareaActividad(tarea, "").subscribe(data => {
			this.actualizacionActividadTarea(data.id);
		}, error => {
			this.nota = null;
			this.idNota = null;
			this.tareaCrearActualizar = {};
			this.servicioAlerta.error('error actualizando Actividad');
			this.loading = false;
		});
	}

	private actualizacionActividadTarea(idTarea) {
		this.loading = true;
		var usuariofilter = this.usuarios.filter(usuario => usuario.nombreusuario.toLowerCase().indexOf(this.actividadSeleccionada.nombreUsuario.toLowerCase()) !== -1);
		var ubicacionFilter = this.actividadSeleccionada.ubicacion !== null ? this.ubicaciones.filter(ubicacion => ubicacion.nombre.toLowerCase().indexOf(this.actividadSeleccionada.ubicacion.toLowerCase()) !== -1) : [];
		this.actividadSeleccionada.idUsuario = usuariofilter[0].idusuario;
		this.actividadSeleccionada.idTarea = idTarea;
		this.actividadSeleccionada.estado = "Re despacho";
		this.actividadSeleccionada.perteneceTarea = true;
		if (ubicacionFilter !== undefined && ubicacionFilter !== null && ubicacionFilter.length > 0) {
			this.actividadSeleccionada.idUbicaciones = [];
			ubicacionFilter.forEach(ubicacion => {
				this.actividadSeleccionada.idUbicaciones.push(ubicacion.idubicacion);
			});
		}
		this.macroService.actualizarActividad(this.actividadSeleccionada, this.storage.get("nomus")).subscribe((data) => {
			this.servicioAlerta.exito('Actividad Actualizada');
			this.editarActividad = false;
			this.historialesActividad = false;
			this.verHistoricoActividad = false;
			this.redireccionarActividad = false;
			this.historicoActividad = [];
			this.historicoEstadosActividad = [];
			this.historicoTarea = [];
			this.modalRef.hide();
			this.ngOnInit();
		}, error => {
			this.editarActividad = false;
			this.historialesActividad = false;
			this.verHistoricoActividad = false;
			this.redireccionarActividad = false;
			this.historicoActividad = [];
			this.historicoEstadosActividad = [];
			this.historicoTarea = [];
			this.modalRef.hide();
			this.loading = false;
			if (error.status === 200) {
				this.servicioAlerta.exito('Actividad Actualizada');
			} else {
				this.servicioAlerta.error('error actualizando Actividad');
			}
		});
	}

	cargarHistorialCompleto(id: string): void {
		let task: any = this.items.filter(item => item.id === id);
		task = task.length > 0 ? task[0] : task;
		this.loading = true;
		if (task.idTarea) {
			this.cargarHistorialTarea(task.idTarea);
		} else {
			alert("La actividad no tiene histórico asociado.");
		}
		this.loading = false;
	}

	cargarHistorialTarea(idActividad: any) {
		this.macroService.listarHistoricoTarea(idActividad).subscribe(
			response => {
				this.historicoTarea = response;
				this.loading = false;
			}, error => {
				this.loading = false;
				this.controlarError(error);
			});
	}

	cargarHistorialActividad(idActividad: any): void {
		this.loading = true;
		this.macroService.listarHistoricoActividad(idActividad).subscribe(
			response => {
				this.historicoActividad = response;
				this.loading = false;
			}, error => {
				this.loading = false;
				this.controlarError(error);
			});
	}

	cargarHistorialEstadoActividad(idActividad: any): void {
		this.loading = true;
		this.macroService.listarHistoricoEstadoActividad(idActividad).subscribe(
			response => {
				this.historicoEstadosActividad = response;
				let Estados = this.historicoEstadosActividad.filter((item, index) => { // se filtra la lista de estados para eliminar los repetidos
					return this.historicoEstadosActividad.indexOf(item) === index;
				})
				var estadosFormulario = []
				for (let i = 0; i < this.formularioActividadSeleccionada.estadosFormulario.length; i++) { // se llena un array con los estados del formulario
					estadosFormulario.push(this.formularioActividadSeleccionada.estadosFormulario[i].nombre);
				}
				document.getElementById("contenedorGf").innerHTML += '<div style="width: 20px"></div>'; // se creo una espacio para alinear los textos
				for (let item of Estados) { // se pintan los estados guardados de la actividad
					document.getElementById("contenedorGf").innerHTML += '<div style="background:#007bff;border-radius:50%;width:30px;height:30px;"></div><div style="background: #007bff;width: 60px;height: 10px;margin-top: 10px;margin-bottom: 10px;"><div style="position: relative;background: #007bff;width: 62px;height: 10px;left: -1px;"></div></div>';
				}
				if (estadosFormulario.length == Estados.length + 1) { // en caso de que  falte un estado
					document.getElementById("contenedorGf").innerHTML += '<div style="background: #6c757d;border-radius: 50%;width: 30px;height: 30px;z-index: 1;"></div>';
				}
				if (Estados.length + 1 < estadosFormulario.length) { // se muestran los estados que no estan en el historial
					var realizado = Estados.length;
					var total = estadosFormulario.length;
					if (Estados[0] == 'Estado sin Seleccionar') {
						var mostrar = total - realizado;
					} else {
						var mostrar = total - realizado - 1;
					}
					for (let i = 0; i < mostrar; i++) {
						document.getElementById("contenedorGf").innerHTML += '<div style="background: #6c757d;border-radius: 50%;width: 30px;height: 30px;z-index: 1;"></div><div style="background: #6c757d;width: 60px;height: 10px;margin-top: 10px;margin-bottom: 10px;"><div style="position: relative;background: #6c757d;width: 62px;height: 10px;left: -1px;"></div></div>';
					}
					document.getElementById("contenedorGf").innerHTML += '<div style="background: #6c757d;border-radius: 50%;width: 30px;height: 30px;z-index: 1;"></div>';
				}
				for (let item of Estados) { // muestra los estados del historial de estados
					document.getElementById("textos").innerHTML += '<div style="width: 90px;padding-right: 10px;text-align: center;">' + item + '</div>';
				}
				var estados = estadosFormulario;
				for (let item of Estados) {
					estados = estados.filter(stds => stds != item);
				}
				for (let item of estados) { // muestra los textos de los estados del formulario que no han sido seleccionado
					document.getElementById("textos").innerHTML += '<div style="width: 90px;padding-right: 10px;text-align: center;">' + item + '</div>';
				}
				this.loading = false;
			}, error => {
				this.loading = false;
				this.controlarError(error);
			});
	}

	cancelar() {
		this.modalRef.hide();
	}

	private acoplamientoHorasMinutos() {
		if (this.horas.length === 0) {
			for (var i = 1; i < 25; i++) {
				if (i < 10) {
					this.horas.push(('0' + i));
				} else {
					this.horas.push(i);
				}
			}
		}
		if (this.minutos.length === 0) {
			for (var i = 0; i < 60; i++) {
				this.minutos.push((i));
			}
		}
	}

	insertarNota() {
		if (this.nota === undefined || this.nota.length === 0) {
			return;
		}
		this.actividadSeleccionada.recomendaciones = this.actividadSeleccionada.recomendaciones === undefined ? [] : this.actividadSeleccionada.recomendaciones;
		if (this.idNota === undefined) {
			this.actividadSeleccionada.recomendaciones.push(this.nota);
			this.nota = undefined;
		} else {
			this.actividadSeleccionada.recomendaciones.splice(this.idNota, 0, this.nota);
			this.actividadSeleccionada.recomendaciones.splice((this.idNota + 1), 1);
			this.idNota = undefined;
			this.nota = undefined;
		}
	}

	quitarNota() {
		this.actividadSeleccionada.recomendaciones.splice(this.idNota, 1);
		this.nota = undefined;
		this.idNota = undefined;
	}

	cargarNota(notaDescripcion, indice) {
		this.idNota = indice;
		this.nota = notaDescripcion;
	}

	private dateFromString(fecha, hora, minuto) {
		let finit = new Date(fecha);
		let month = (finit.getMonth() + 1) > 9 ? (finit.getMonth() + 1) : '0' + (finit.getMonth() + 1);
		let day = finit.getDate() > 9 ? (finit.getDate() + 1) : '0' + (finit.getDate() + 1);
		return new Date(finit.getFullYear() + '-' + month + '-' + day + ' ' + hora + ':' + minuto + ':00');
	}

	private getDifMont(fechaIni, fechaFin) {
		let fI = new Date(fechaIni).getTime()
		let fF = new Date(fechaFin).getTime()
		return Math.round((fI - fF) / (1000 * 60 * 60 * 24))
	}

	generarNuevaActividad() {
		this.formularioToNewActivity = null;
		this.actividadSeleccionada = null;
		this.formularioActividadSeleccionada = null;
		this.nuevaActividad = false;
		this.ubicacionAsociadaG = null;
		this.modalRef = this.modalService.show(this.newActivityModal, { class: 'modal-lg', backdrop: 'static' });
	}

	verificarCamposFormularioNuevaActividad(idformulario): void {
		if(idformulario && idformulario.length > 0){
			this.macroService.formulariosPorId(idformulario).subscribe((response: any) => {
				this.formularioToNewActivity = response;
				this.estadosFormularioSeleccionadoBusqueda = response.estadoActividadSeleccionado ? response.estadoActividadSeleccionado.map((data) => {
					return JSON.parse(data);
				}) : [];
				this.formularioToNewActivity.nombreUsuario = this.storage.get("nomus");
			}, (error) => {
				console.error('error', error);
			});
		}
	}

	replicarPlantilla(elemento) {
		// verificar si el elemento es de tipo "masterDetails" y tiene una propiedad "plantilla" que es un objeto
		let indexMstr = 0
		if (elemento.tipo === "masterDetails" && elemento.plantilla && typeof elemento.plantilla === "object") {

			// crear una copia profunda del objeto "plantilla"
			const filasMaestroDetalle = JSON.parse(JSON.stringify(elemento.plantilla));

			if (elemento.filasMaestroDetalle == undefined) {
				// cambiar el nombre interno de "plantilla" a "filasMaestroDetalle"
				elemento.filasMaestroDetalle = [filasMaestroDetalle]; // colocar el objeto en un array
			} else {
				indexMstr = elemento.filasMaestroDetalle.length;
				elemento.filasMaestroDetalle.push(filasMaestroDetalle);
			}

			// cambiar el nombre interno de "elementosRepetitivos" a "elementos" (se agrega)
			elemento.filasMaestroDetalle[indexMstr].elementos = filasMaestroDetalle.elementosRepetitivos;

			// agregar el campo "nombre" con el valor de "label"
			elemento.filasMaestroDetalle[indexMstr].nombre = elemento.label;

			// agregar el campo "editable" con el valor true
			elemento.filasMaestroDetalle[indexMstr].editable = true;

			// agregar el campo "valorDiligenciado" con el valor ' ' a cada elemento en el array
			elemento.filasMaestroDetalle[indexMstr].elementos.forEach(elementoRepetitivo => {
				elementoRepetitivo.valorDiligenciado = '';
			});
			// se elimina el campo elementosRepetitivos (que es copiado del campo Platilla)
			delete elemento.filasMaestroDetalle[indexMstr].elementosRepetitivos;
		}
		this.recorrerActividadSeleccionada();
	}

	puedeAgregarMaestroDetalle(elemento): boolean {
		const filas = elemento.filasMaestroDetalle ? elemento.filasMaestroDetalle.length : 0;
		const maximo = elemento.cantidadMaxReg ? elemento.cantidadMaxReg : 99;
		return filas < maximo;
	}

	agregarMaestro(elemento) {
		if (!this.puedeAgregarMaestroDetalle(elemento)) {
			return;
		}
		this.replicarPlantilla(elemento);
	}

	//elimina una fila de un maestro detalle
	eliminarMaestro(paginaActual, elementosCount, maestroDetalleCount) {
		this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle.splice(maestroDetalleCount, 1);
		this.recorrerActividadSeleccionada();
	}

	esOperacionValida(input: string): boolean {
		// expresión regular que permite números, espacios y los operadores + - ( ) / * % , .
		const operables = /^[0-9\s\+\-\(\)\/\*\%\,\.]+$/;

		// verifica si el string cumple con el patrón
		return operables.test(input);
	}

	recorrerActividadSeleccionada() {
		this.loading = true;
		for (let i = 0; i < this.actividadSeleccionada.paginas.length; i++) {
			for (let j = 0; j < this.actividadSeleccionada.paginas[i].elementos.length; j++) {
				//valida si el elemento tiene un campo 'tipo' si no le asigna el valor de 'identificador'
				if(!('tipo' in this.actividadSeleccionada.paginas[i].elementos[j]) && this.actividadSeleccionada.paginas[i].elementos[j].identificador){
					this.actividadSeleccionada.paginas[i].elementos[j].tipo = this.actividadSeleccionada.paginas[i].elementos[j].identificador;
				}
				// anade fecha y hora actual a elemento tipo dateTime
				if (this.actividadSeleccionada.paginas[i].elementos[j].tipo == "dateTime" && this.actividadSeleccionada.paginas[i].elementos[j].valorDefecto == 'CURRENTDATE' &&
					(!this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado || this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado === '')) {
					this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado = this.fechaService.obtenerFormatoDateActual();
				}
				// elimina la paginacion en elementos
				if (this.guardandoActividad && this.actividadSeleccionada.paginas[i].elementos[j].pagina !== null) {
					delete this.actividadSeleccionada.paginas[i].elementos[j].pagina;
				}
				// anade hora actual a elemento tipo time
				else if (this.actividadSeleccionada.paginas[i].elementos[j].tipo == "time" && this.actividadSeleccionada.paginas[i].elementos[j].valorDefecto == 'CURRENTDATE' &&
					(!this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado || this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado === '')) {
					// obtén la hora actual
					const horaActual = new Date();

					// obtiene horas y minutos
					const horas = horaActual.getHours();
					const minutos = horaActual.getMinutes();

					// formatea horas y minutos con ceros a la izquierda si es necesario
					const horasString = horas.toString().padStart(2, '0');
					const minutosString = minutos.toString().padStart(2, '0');

					// construye la cadena en formato HH:MM
					const horaActualString = `${horasString}:${minutosString}`;

					this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado = horaActualString;
				}
				// anade fecha actual a elemento tipo date
				else if (this.actividadSeleccionada.paginas[i].elementos[j].tipo == "date" && this.actividadSeleccionada.paginas[i].elementos[j].valorDefecto == 'CURRENTDATE' &&
					(!this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado || this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado === '')) {
					// obtén la fecha actual
					const fechaActual = new Date();

					// obtiene año, mes y día
					const anio = fechaActual.getFullYear();
					const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0'); // Nota: getMonth devuelve meses de 0 a 11
					const dia = fechaActual.getDate().toString().padStart(2, '0');

					// construye la cadena en formato AAAA-MM-DD
					const fechaActualString = `${anio}-${mes}-${dia}`;

					this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado = fechaActualString;
				}
				// se anaden opciones a las listas de items segun ubicacion asociada a la actividad selecionada
				if (this.actividadSeleccionada.paginas[i].elementos[j].tipo == "lista_items" && this.ubicacionAsociadaG !== null && this.ubicacionAsociadaG !== undefined && this.ubicacionAsociadaG !== '') {
					this.macroService.consultarListaItemsId(this.actividadSeleccionada.paginas[i].elementos[j].listaClienteId).subscribe((response) => {
						if(response !== null && 'listaItem' in response){
							this.actividadSeleccionada.paginas[i].elementos[j].opciones = response.listaItem[this.ubicacionAsociadaG];
						}
					});
				}
				// eliminacion de opciones de listas de items al momento de guardar
				if (this.guardandoActividad && this.actividadSeleccionada.paginas[i].elementos[j].tipo == "lista_items" && this.actividadSeleccionada.paginas[i].elementos[j].opciones) {
					delete this.actividadSeleccionada.paginas[i].elementos[j].opciones;
				}
				// ejecucion de calculadora
				if (this.actividadSeleccionada.paginas[i].elementos[j].tipo == "calculadora" && this.actividadSeleccionada.paginas[i].elementos[j].formula) {
					const regex = /[()+\-/*%]/g;
					let operacion = this.actividadSeleccionada.paginas[i].elementos[j].formula;
					const palabras = operacion.split(regex).filter(palabra => palabra.trim() !== '');
					for (let i1 = 0; i1 < palabras.length; i1++) {
						for (let j1 = 0; j1 < this.actividadSeleccionada.paginas[i].elementos.length; j1++) {
							if (this.actividadSeleccionada.paginas[i].elementos[j1].label && palabras[i1].trim() === this.actividadSeleccionada.paginas[i].elementos[j1].label.trim()) {
								if ((!this.actividadSeleccionada.paginas[i].elementos[j1].valorDiligenciado || this.actividadSeleccionada.paginas[i].elementos[j1].valorDiligenciado !== '') &&
									this.actividadSeleccionada.paginas[i].elementos[j1].valorDefecto && this.actividadSeleccionada.paginas[i].elementos[j1].valorDefecto !== '') {
									this.actividadSeleccionada.paginas[i].elementos[j1].valorDiligenciado = this.actividadSeleccionada.paginas[i].elementos[j1].valorDefecto;
								}
								if (this.actividadSeleccionada.paginas[i].elementos[j1].valorDiligenciado && this.actividadSeleccionada.paginas[i].elementos[j1].valorDiligenciado !== '') {
									operacion = operacion.replace(new RegExp(palabras[i1], 'g'), this.actividadSeleccionada.paginas[i].elementos[j1].valorDiligenciado);
								}
								break;
							}
						}
					}
					if (this.esOperacionValida(operacion)) {
						this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado = eval(operacion).toString();
					}
				}
				// campo que toma los valores internos de las calculadoras dentro de los maestros detalle
				if (this.actividadSeleccionada.paginas[i].elementos[j].tipo === "numero" &&
					this.actividadSeleccionada.paginas[i].elementos[j].idmaestrodetalle &&
					this.actividadSeleccionada.paginas[i].elementos[j].labelcampocalculadora) {

					for (let x = 0; x < this.actividadSeleccionada.paginas[i].elementos.length; x++) {
						if (this.actividadSeleccionada.paginas[i].elementos[x].tipo === "masterDetails" &&
							this.actividadSeleccionada.paginas[i].elementos[x].filasMaestroDetalle &&
							this.actividadSeleccionada.paginas[i].elementos[x].idMaster === this.actividadSeleccionada.paginas[i].elementos[j].idmaestrodetalle) {

							this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado = 0;

							for (let y = 0; y < this.actividadSeleccionada.paginas[i].elementos[x].filasMaestroDetalle.length; y++) {
								for (let y1 = 0; y1 < this.actividadSeleccionada.paginas[i].elementos[x].filasMaestroDetalle[y].elementos.length; y1++) {
									if (this.actividadSeleccionada.paginas[i].elementos[j].labelcampocalculadora === this.actividadSeleccionada.paginas[i].elementos[x].filasMaestroDetalle[y].elementos[y1].label &&
										this.actividadSeleccionada.paginas[i].elementos[x].filasMaestroDetalle[y].elementos[y1].tipo === "calculadora" &&
										this.actividadSeleccionada.paginas[i].elementos[x].filasMaestroDetalle[y].elementos[y1].valorDiligenciado &&
										this.actividadSeleccionada.paginas[i].elementos[x].filasMaestroDetalle[y].elementos[y1].valorDiligenciado !== "") {
										this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado = this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado + parseFloat(this.actividadSeleccionada.paginas[i].elementos[x].filasMaestroDetalle[y].elementos[y1].valorDiligenciado);
									}
								}
							}
							this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado = this.actividadSeleccionada.paginas[i].elementos[j].valorDiligenciado.toString();
						}
					}
				}
				// recorre los maestros detalle
				if (this.actividadSeleccionada.paginas[i].elementos[j].tipo === "masterDetails" &&
					this.actividadSeleccionada.paginas[i].elementos[j].plantilla &&
					typeof this.actividadSeleccionada.paginas[i].elementos[j].plantilla === "object" &&
					this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle) {
					for (let i1 = 0; i1 < this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle.length; i1++) {
						// anade la ubicacion a las filas de los maestros detalle
						if (this.actividadSeleccionada.paginas[0].elementos[0].tipo === 'LocationForm' && !this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].asociadoUbicacion && !this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].idUbicacion) {
							this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].asociadoUbicacion = true;
							this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].idUbicacion = this.ubicacionAsociadaG;
						}
						for (let j1 = 0; j1 < this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos.length; j1++) {
							//valida si el elemento tiene un campo 'tipo' si no le asigna el valor de 'identificador'
							if(!('tipo' in this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1]) && this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].identificador){
								this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].tipo = this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].identificador;
							}
							// anade fecha y hora actual a elemento tipo dateTime maestro detalle
							if (this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].tipo == "dateTime" && this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDefecto == 'CURRENTDATE' &&
								(!this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDiligenciado || this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDiligenciado === '')) {
								this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDiligenciado = this.fechaService.obtenerFormatoDateActual();
							}
							// anade hora actual a elemento tipo time  maestro detalle
							else if (this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].tipo == "time" && this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDefecto == 'CURRENTDATE' &&
								(!this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDiligenciado || this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDiligenciado === '')) {
								// obtén la hora actual
								const horaActual = new Date();

								// obtiene horas y minutos
								const horas = horaActual.getHours();
								const minutos = horaActual.getMinutes();

								// formatea horas y minutos con ceros a la izquierda si es necesario
								const horasString = horas.toString().padStart(2, '0');
								const minutosString = minutos.toString().padStart(2, '0');

								// construye la cadena en formato HH:MM
								const horaActualString = `${horasString}:${minutosString}`;

								this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDiligenciado = horaActualString;
							}
							// anade fecha actual a elemento tipo date  maestro detalle
							else if (this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].tipo == "date" && this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDefecto == 'CURRENTDATE' &&
								(!this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDiligenciado || this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDiligenciado === '')) {
								// obtén la fecha actual
								const fechaActual = new Date();

								// obtiene año, mes y día
								const anio = fechaActual.getFullYear();
								const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0'); // Nota: getMonth devuelve meses de 0 a 11
								const dia = fechaActual.getDate().toString().padStart(2, '0');

								// construye la cadena en formato AAAA-MM-DD
								const fechaActualString = `${anio}-${mes}-${dia}`;

								this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDiligenciado = fechaActualString;
							}
							// se anaden opciones a las listas de items segun ubicacion asociada a la actividad selecionada
							if (this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].tipo == "lista_items") {
								this.macroService.consultarListaItemsId(this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].listaClienteId).subscribe((response) => {
									this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].opciones = response.listaItem[this.ubicacionAsociadaG];
								});
							}
							// eliminacion de opciones de listas de items al momento de guardar
							if (this.guardandoActividad && this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].tipo == "lista_items" && this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].opciones) {
								delete this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].opciones;
							}
							// ejecucion de calculadora  maestro detalle
							if (this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].tipo == "calculadora" && this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].formula) {
								const regex = /[()+\-/*%]/g;
								let operacion = this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].formula;
								const palabras = operacion.split(regex).filter(palabra => palabra.trim() !== '');
								for (let ip = 0; ip < palabras.length; ip++) {
									for (let jp = 0; jp < this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos.length; jp++) {
										if (palabras[ip].trim() === this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[jp].label.trim()) {
											if ((!this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[jp].valorDiligenciado || this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[jp].valorDiligenciado !== '') &&
												this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[jp].valorDefecto && this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[jp].valorDefecto !== '' &&
												this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[jp].tipo === 'numero') {
												this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[jp].valorDiligenciado = this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[jp].valorDefecto;
											}
											if (this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[jp].valorDiligenciado &&
												this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[jp].valorDiligenciado !== '') {
												operacion = operacion.replace(new RegExp(palabras[ip], 'g'), this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[jp].valorDiligenciado);
											}
											break;
										}
									}
								}
								if (this.esOperacionValida(operacion)) {
									this.actividadSeleccionada.paginas[i].elementos[j].filasMaestroDetalle[i1].elementos[j1].valorDiligenciado = eval(operacion).toString();
								}
							}
						}
					}
				}

			}
		}
		this.loading = false;
	}

	valoresAsociados(opcionNombre, paginaActual, elementosCount, maestroDetalleCount, elementoMaestroCount) {

		const opcionSeleccionada = this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle[maestroDetalleCount].elementos[elementoMaestroCount].opciones.find(opcion => opcion.nombre === opcionNombre);

		this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle[maestroDetalleCount].elementos[elementoMaestroCount].idItem = opcionSeleccionada.id;

		this.macroService.consultarItemId(opcionSeleccionada.id).subscribe((response) => {
			this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle[maestroDetalleCount].elementos[elementoMaestroCount].valorDiligenciado = opcionSeleccionada.nombre;
			for (let j = 0; j < this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle[maestroDetalleCount].elementos.length; j++) {
				if (this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle[maestroDetalleCount].elementos[j].nombrecampoasociar &&
					this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle[maestroDetalleCount].elementos[j].nombrecampoasociar !== '') {
					this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle[maestroDetalleCount].elementos[j].valorDiligenciado = response[this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].filasMaestroDetalle[maestroDetalleCount].elementos[j].nombrecampoasociar].replace(",", ".");
				}
			}
		})
	}

	valoresAsociadosSencillos(opcionNombre, paginaActual, elementosCount) {

		const opcionSeleccionada = this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].opciones.find(opcion => opcion.nombre === opcionNombre);

		this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].idItem = opcionSeleccionada.id;

		this.macroService.consultarItemId(opcionSeleccionada.id).subscribe((response) => {
			this.actividadSeleccionada.paginas[paginaActual].elementos[elementosCount].valorDiligenciado = opcionSeleccionada.nombre;
			for (let j = 0; j < this.actividadSeleccionada.paginas[paginaActual].elementos.length; j++) {
				if (this.actividadSeleccionada.paginas[paginaActual].elementos[j].nombrecampoasociar &&
					this.actividadSeleccionada.paginas[paginaActual].elementos[j].nombrecampoasociar !== '') {
					this.actividadSeleccionada.paginas[paginaActual].elementos[j].valorDiligenciado = response[this.actividadSeleccionada.paginas[paginaActual].elementos[j].nombrecampoasociar].replace(",", ".");
				}
			}
		})
	}

	crearNuevaActividadFormulario() {
		if (this.formularioToNewActivity !== undefined && this.formularioToNewActivity !== null) {
			this.loading = true;
			this.formularioToNewActivity.identificador = this.formularioToNewActivity.id;
			this.formularioToNewActivity.id = null;
			this.formularioToNewActivity.estado = 'Creado';
			this.formularioToNewActivity.fechaModificacion = null;
			this.formularioToNewActivity.fechaIngreso = null;
			this.formularioToNewActivity.nombreUsuario = this.storage.get("nomus");
			this.macroService.crearActividad(this.formularioToNewActivity).subscribe((response) => {
				this.idActivityNew = response;
				this.loading = false;
				this.servicioAlerta.info('Creacion de Actividad Inicializada');
				this.nuevaActividad = true;
				this.macroService.formularioId(this.idActivityNew).subscribe(data => {
					this.actividadSeleccionada = data;
					this.actividadSeleccionada.creadaCloud = true;
					this.paginas = this.actividadSeleccionada.paginas;
					this.numerosPagina = Array.from({ length: this.paginas.length }, (x, i) => i);
					this.paginaActual = 0;
					this.informacionPagina = this.paginas[this.paginaActual];
					this.cantidadElementos = Array.from({ length: this.actividadSeleccionada.paginas[this.paginaActual].elementos.length }, (x, i) => i);
					this.macroService.ubicacionesPorCliente(this.idEmpresa).subscribe(response => {
						this.ubicacionesEmpresa = response;
					});

					this.recorrerActividadSeleccionada();
					this.iniciarCronometro();
				});
			}, error1 => {
				this.servicioAlerta.errorMensaje('error creando la Actividad');
				this.loading = false;
			});
		} else {
			alert("Debe seleccionar un formulario.");
		}
	}

	crearActividadFormulario(idformulario) {
		if (idformulario !== undefined && idformulario !== null && idformulario !== "") {
			let actividadFormulario = null;
			this.macroService.formulariosPorId(idformulario).subscribe(data => {
				actividadFormulario = data;
				actividadFormulario.id = null;
				actividadFormulario.identificador = idformulario;
				actividadFormulario.estado = 'Finalizado';
				actividadFormulario.fechaModificacion = null;
				actividadFormulario.fechaIngreso = null;
				actividadFormulario.nombreUsuario = this.storage.get("nomus");
				this.macroService.crearActividad(actividadFormulario).subscribe(() => {
					this.modalRef.hide();
					this.loading = false;
					this.servicioAlerta.exito('Actividad Creada');
					this.ngOnInit()
					this.nuevaActividad = false;
				}, error1 => {
					this.servicioAlerta.errorMensaje('error creando la Actividad');
					this.loading = false;
				});
			}, () => {
				this.servicioAlerta.errorMensaje('error consultando el formulario');
				this.loading = false;
			});
		}
	}

	isArray(elem) {
		if (typeof elem === 'object') {
			return true;
		}
		return false;
	}

	getHistoricoActividad(actividad) {
		this.cargandoHistoricoActividades = true;
		this.macroService.listarHistoricoActividad(actividad.id).subscribe(
			response => {
				this.historicoActividades = response;
				this.cargandoHistoricoActividades = false;
			}, error => {
				this.cargandoHistoricoActividades = false;
				this.controlarError(error);
			}
		);
	}

	ngAfterContentChecked(): void {
		this.changeDetector.detectChanges();
	}

	verDependencia(elementoActual, elementos): void {
		let ret_data = 0;
		elementos.forEach(element => {
			if (element.opciones !== undefined && element.opciones.length > 0) {
				element.opciones.forEach(opcelm => {
					if (opcelm.opcionesDependecia !== undefined) {
						let data = opcelm.opcionesDependecia.filter(xdepen => xdepen.seleccionado && xdepen.label === elementoActual.label);
						if (data.length > 0) {
							ret_data += 1;
						}
					}
				});
			}
		});
		if (ret_data > 0) {
			elementoActual.idependiente = true;
		} else {
			elementoActual.idependiente = false;
		}
	}

	//#region DeleteActivities
	addActivityToDelete($event: any, activity: any) {
		if ($event.target.checked) {
			this.activitiesSelectedToDelete.push(activity.id);
		} else {
			let indexFound = this.activitiesSelectedToDelete.findIndex(id => id === activity.id);
			if (indexFound !== -1) {
				this.activitiesSelectedToDelete.splice(indexFound, 1);
			}
		}
	}

	toDeleteSelectedActivities() {
		if (this.activitiesSelectedToDelete.length > 0) {
			const sure = prompt(`Está a punto de eliminar la información de ${this.activitiesSelectedToDelete.length} actividades, tenga en cuenta que una vez realizado el proceso no se podrá recuperar esta información. Si desea continuar con el proceso, por favor escriba la palabra BORRAR (en mayusculas) para confirmar la acción.`);
			if (sure === 'BORRAR') {
				this.loading = true;
				this.macroService.getEmpresaMa(this.idEmpresa).subscribe(
					dataEmpresa => {
						this.macroService.toDeleteSelectedActivities(this.idEmpresa, this.activitiesSelectedToDelete, dataEmpresa.nombre, this.nombreUsuarioLog, this.idUsuarioLog).subscribe(
							response => {
								this.loading = false;
								this.servicioAlerta.exito("Se han eliminado las actividades correctamente");
								this.ngOnInit();
							}, error => {
								this.servicioAlerta.error(`No se ha logrado eliminar las actividades, intentelo de nuevo. Error: ${error}`);
								this.loading = false;
							}
						);
					}, error => {
						this.servicioAlerta.error(`Error obteniendo la informacio de la empresa, intentelo de nuevo. Error: ${error}`);
						this.loading = false;
					}
				);
			}
		} else {
			alert("No se han seleccionado actividades para eliminar.");
		}
	}
	//#endregion

	copyToClipboard(item) {
		document.addEventListener('copy', (e: ClipboardEvent) => {
			e.clipboardData.setData('text/plain', (item));
			e.preventDefault();
			document.removeEventListener('copy', null);
		});
		document.execCommand('copy');
		alert("Secuencia copiada al portapapeles");
	}

	verifyEstadosFormularioSeleccionado(formSelected: any): void {
		let formSelectedFound = this.formularios.filter((frm) => frm.nombre === formSelected);
		if (formSelectedFound.length > 0) {
			let form = formSelectedFound[0];
			this.macroService.formulariosPorId(form.identificador).subscribe(
				(response) => {
					this.estadosFormularioSeleccionadoBusqueda = response.estadoActividadSeleccionado ?
						response.estadoActividadSeleccionado.map((data) => {
							return JSON.parse(data);
						}) : [];
				}
			);
		}
	}

	redireccionar() {
		if (!this.redireccionarActividad) {
			this.redireccionarActividad = true;
			this.editarActividad = false;
			this.historialesActividad = false;
		} else {
			this.redireccionarActividad = false;
			this.editarActividad = false;
			this.historialesActividad = false;
		}
	}

	editar() {
		if (!this.editarActividad) {
			this.ubicacionAsociadaG = null;
			this.redireccionarActividad = false;
			this.editarActividad = true;
			this.historialesActividad = false;
			if (this.actividadSeleccionada.paginas[0].elementos[0].identificador === 'LocationForm') {
				this.ubicacionAsociadaG = this.actividadSeleccionada.paginas[0].elementos[0].valorDiligenciado.split(',')[0];
			}
			this.actividadSeleccionada.editadaCloud = true;
			this.recorrerActividadSeleccionada();
		} else {
			this.redireccionarActividad = false;
			this.editarActividad = false;
			this.historialesActividad = false;
		}
	}

	ejecutarTareaR() {
		const objeto = { idempresa: this.idEmpresa };
		this.usuarioTR = false;
		this.nota = null;
		this.tareaR = objeto;
		this.usuariosBusqueda = this.usuarios;
		this.tareaR.nombre = 'Tarea Rapida';
		this.tareaR.multiUbicacionSinZona = true;
		this.campoBusquedaFormulario = '';
		this.busquedaFormulario();
		this.campoBusquedaUsuario = '';
		this.busquedaUsuario();
		// obtén la hora actual
		const fechaHoraActual = new Date();
		fechaHoraActual.setMinutes(fechaHoraActual.getMinutes() + 2);
		this.fechaHoraActualTareaR = fechaHoraActual;

		// obtiene horas y minutos
		const horas = fechaHoraActual.getHours();
		const minutos = fechaHoraActual.getMinutes();

		// formatea horas y minutos con ceros a la izquierda si es necesario
		this.tareaR.horainicio = horas.toString().padStart(2, '0');
		this.tareaR.minutoinicio = minutos.toString().padStart(2, '0');

		this.horaInicio = this.tareaR.horainicio + ':' + this.tareaR.minutoinicio;

		// obtiene año, mes y día
		const anio = fechaHoraActual.getFullYear();
		const mes = (fechaHoraActual.getMonth() + 1).toString().padStart(2, '0'); // Nota: getMonth devuelve meses de 0 a 11
		const dia = fechaHoraActual.getDate().toString().padStart(2, '0');

		// construye la cadena en formato AAAA-MM-DD
		this.fechainicio = `${anio}-${mes}-${dia}`;

		// Crear una nueva fecha sumando 16 minutos
		const fechaHoraActualFin = new Date(fechaHoraActual.getTime());
		fechaHoraActualFin.setMinutes(fechaHoraActual.getMinutes() + 16);

		// obtiene horas y minutos
		const horasf = fechaHoraActualFin.getHours();
		const minutosf = fechaHoraActualFin.getMinutes();

		// formatea horas y minutos con ceros a la izquierda si es necesario
		this.tareaR.horafinalizacion = horasf.toString().padStart(2, '0');
		this.tareaR.minutofinalizacion = minutosf.toString().padStart(2, '0');

		this.horaFin = this.tareaR.horafinalizacion + ':' + this.tareaR.minutofinalizacion;

		// obtiene año, mes y día
		const aniof = fechaHoraActualFin.getFullYear();
		const mesf = (fechaHoraActualFin.getMonth() + 1).toString().padStart(2, '0'); // Nota: getMonth devuelve meses de 0 a 11
		const diaf = fechaHoraActualFin.getDate().toString().padStart(2, '0');

		// construye la cadena en formato AAAA-MM-DD
		this.fechafin = `${aniof}-${mesf}-${diaf}`;

		this.tareaR.tiempoAntesExpira = 10;
		this.tareaR.tiempoDespuesExpira = 20;
		this.tareaR.tiempoEliminar = 40;
		this.modalRef = this.modalService.show(this.tareaRapidaModal, { class: 'modal-lg', backdrop: 'static' });
	}

	private verificacionArrayTareaR(objeto: any) {
		if (!Array.isArray(objeto.idubicaciones)) {
			var idUbicacionAuxiliar = objeto.idubicaciones;
			objeto.idubicaciones = [];
			objeto.idubicaciones.push(idUbicacionAuxiliar);
		}
		if (!Array.isArray(objeto.nombreUsuarios)) {
			var nombreUsuarioAuxiliar = objeto.nombreUsuarios;
			objeto.nombreUsuarios = [];
			if (nombreUsuarioAuxiliar && nombreUsuarioAuxiliar != null) {
				objeto.nombreUsuarios.push(nombreUsuarioAuxiliar);
			}
		}
	}

	generarTareaRapida(objeto: any) {
		this.loading = true;
		objeto.idempresa = this.idEmpresa;
		objeto.despachador = this.storage.get("nomus");
		let today = new Date();

		this.actualizandoFechaTareaR();
		this.verificacionArrayTareaR(objeto);
		this.verificacionAsignacionTarea(objeto);

		if (this.fechainicio === '' || this.fechainicio === null || this.fechainicio === undefined) {
			alert('La fecha de inicio es requerida');
			return;
		}
		if (this.fechafin === '' || this.fechafin === null || this.fechafin === undefined) {
			alert('La fecha fin es requerida');
			return;
		}
		let ini = this.dateFromString(this.fechainicio, this.tareaR.horainicio, this.tareaR.minutoinicio);
		if (ini < today) {
			alert('La fecha y hora de inicio debe ser mayor a la fecha y hora actual.');
			this.formInvalido = true;
			return;
		}
		let end = this.dateFromString(this.fechafin, this.tareaR.horafin, this.tareaR.minutofin);
		if (end < today) {
			alert('La fecha y hora fin debe ser mayor a la fecha y hora actual.');
			this.formInvalido = true;
			return;
		}
		if (ini > end) {
			alert('La fecha y hora fin debe ser mayor a la fecha y hora inicial.');
			this.formInvalido = true;
			return;
		}

		let difMonth = this.getDifMont(this.fechafin, this.fechainicio);
		if (difMonth > 61) {
			alert('No se puede crear tareas con más de DOS meses de diferencia.');
			this.formInvalido = true;
			return;
		}
		if (objeto.identificadorformulario === null && objeto.identificadorformulario === undefined) {
			alert('No se puede crear tareas sin un formulario.');
			this.formInvalido = true;
			return;
		}
		if (objeto.tiempoAntesExpira && objeto.tiempoAntesExpira < 0) {
			alert('El tiempo de notifiación antes del inicio de la tarea debe ser mayor o igual a cero.');
			this.formInvalido = true;
			return;
		}
		if (objeto.tiempoDespuesExpira && objeto.tiempoDespuesExpira < 0) {
			alert('Los minutos programados para después del fin de la tarea deben ser mayor o igual a cero.');
			this.formInvalido = true;
			return;
		}
		if (objeto.tiempoEliminar && objeto.tiempoEliminar < 0) {
			alert('Los Minutos para Eliminar deben ser mayor o igual a cero.');
			this.formInvalido = true;
			return;
		}
		if (objeto.tiempoEliminar && objeto.tiempoDespuesExpira && objeto.tiempoEliminar <= objeto.tiempoDespuesExpira) {
			alert('Los Minutos para Eliminar deben ser mayor que los Minutos después del fin de la tarea.');
			this.formInvalido = true;
			return;
		}
		if (objeto.idubicaciones !== undefined && objeto.idubicaciones !== null && objeto.idubicaciones.length > 1 &&
			objeto.nombreUsuarios !== undefined && objeto.nombreUsuarios !== null && objeto.nombreUsuarios.length > 0) {
			alert('Se genero una configuracion de multiubicacion y multiusuario que no esta permitida, verificar informacion');
			this.formInvalido = true;
			return;
		}
		if (!objeto.nombre || objeto.nombre.length < 1) {
			this.formInvalido = true;
			return;
		}

		objeto.fechainicio = this.fechainicio !== undefined ? new Date(this.fechainicio).getTime() : null;
		objeto.fechainicioTexto = this.fechainicio
		objeto.fechafin = this.fechafin !== undefined ? new Date(this.fechafin).getTime() : null;
		objeto.fechafinTexto = this.fechafin
		objeto.fecharepeticion = this.fecharepeticion !== undefined ? new Date(this.fecharepeticion).getTime() : null;
		objeto.fecharepeticionTexto = this.fecharepeticion

		if (objeto.idestado) {
			objeto.estado = this.estados.filter(obj => obj.idestado === objeto.idestado)[0].nombre;
		}

		this.formInvalido = false;
		this.macroService.crearTarea(objeto).subscribe(() => {
			this.servicioAlerta.exito('Tarea Creada');
			this.ngOnInit();
			this.loading = false;
			this.nota = null;
			this.idNota = null;
			this.modalRef.hide();
		}, error => {
			this.servicioAlerta.error('Tarea No Creada Error');
			this.loading = false;
			this.nota = null;
			this.idNota = null;
			this.modalRef.hide();
		});
	}

	private verificacionAsignacionTarea(objeto: any) {
		if (objeto.identificadorformulario !== null && objeto.identificadorformulario !== undefined) {
			objeto.nombreformulario = this.formulariosBusqueda.filter(obj => obj.identificador === objeto.identificadorformulario)[0].nombre;
		}
		if (objeto.idzonatrabajo !== null && objeto.idzonatrabajo !== undefined) {
			objeto.zonatrabajo = this.zonasBusqueda.filter(obj => obj.idzonatrabajo === objeto.idzonatrabajo)[0].nombre;
		}
		if (objeto.idubicaciones !== null && objeto.idubicaciones !== undefined && objeto.idubicaciones.length > 0) {
			objeto.ubicaciones = [];
			var ubicacionesEncontradas = this.ubicaciones.filter(obj => objeto.idubicaciones.indexOf(obj.idubicacion) > -1);
			ubicacionesEncontradas.forEach(obj => objeto.ubicaciones.push(obj.nombre));
		}
	}

	adicionarFormularioTareaRapida(idFormulario) {
		const form = this.formularios.filter(formulario => formulario.identificador === idFormulario)[0];
		if (form && form !== undefined) {
			this.tareaR.identificadorformulario = form.identificador;
			this.tareaR.nombreformulario = form.nombre;
		}
	}

	ubicacionUsuarios(event: any) {
		const ubicacionSeleccionada = this.ubicaciones.find(ubicacion => ubicacion.idubicacion === event.target.value);
		if (ubicacionSeleccionada.idzonatrabajo && ubicacionSeleccionada.idzonatrabajo !== '') {
			this.macroService.usuariosPorClienteZona(this.idEmpresa, ubicacionSeleccionada.idzonatrabajo).subscribe(response => {
				this.usuariosBusqueda = response;
				this.usuarioTR = true;
			});
		}
	}

	insertarNotaTareaR() {
		if (this.nota === undefined || this.nota.length === 0) {
			return;
		}
		this.tareaR.recomendaciones = this.tareaR.recomendaciones === undefined ? [] : this.tareaR.recomendaciones;
		if (this.idNota === undefined) {
			this.tareaR.recomendaciones.push(this.nota);
			this.nota = undefined;
		} else {
			this.tareaR.recomendaciones.splice(this.idNota, 0, this.nota);
			this.tareaR.recomendaciones.splice((this.idNota + 1), 1);
			this.idNota = undefined;
			this.nota = undefined;
		}
	}

	cargarNotaTareaR(notaDescripcion) {
		this.idNota = this.tareaR.recomendaciones.indexOf(notaDescripcion);
		this.nota = notaDescripcion;
	}

	quitarNotaTareaR() {
		this.tareaR.recomendaciones.splice(this.idNota, 1);
		this.nota = undefined;
		this.idNota = undefined;
	}

	sonIgualesSinSegundos(fecha1: Date, fecha2: Date): boolean {
		// Establecer los segundos a 0 para ambas fechas
		const fecha1SinSegundos = new Date(fecha1);
		fecha1SinSegundos.setSeconds(0);

		const fecha2SinSegundos = new Date(fecha2);
		fecha2SinSegundos.setSeconds(0);

		// Comparar las fechas sin segundos
		return fecha1SinSegundos.getTime() === fecha2SinSegundos.getTime();
	}

	actualizandoFechaTareaR() {
		if (this.sonIgualesSinSegundos(this.fechaHoraActualTareaR, new Date()) || this.fechaHoraActualTareaR <= new Date()) {
			// obtén la hora actual
			const fechaHoraActual = new Date();
			fechaHoraActual.setMinutes(fechaHoraActual.getMinutes() + 2);

			// obtiene horas y minutos
			const horas = fechaHoraActual.getHours();
			const minutos = fechaHoraActual.getMinutes();

			// formatea horas y minutos con ceros a la izquierda si es necesario
			this.tareaR.horainicio = horas.toString().padStart(2, '0');
			this.tareaR.minutoinicio = minutos.toString().padStart(2, '0');

			this.horaInicio = this.tareaR.horainicio + ':' + this.tareaR.minutoinicio;

			// obtiene año, mes y día
			const anio = fechaHoraActual.getFullYear();
			const mes = (fechaHoraActual.getMonth() + 1).toString().padStart(2, '0'); // Nota: getMonth devuelve meses de 0 a 11
			const dia = fechaHoraActual.getDate().toString().padStart(2, '0');

			// construye la cadena en formato AAAA-MM-DD
			this.fechainicio = `${anio}-${mes}-${dia}`;

			// Crear una nueva fecha sumando 16 minutos
			const fechaHoraActualFin = new Date(fechaHoraActual.getTime());
			fechaHoraActualFin.setMinutes(fechaHoraActual.getMinutes() + 16);

			// obtiene horas y minutos
			const horasf = fechaHoraActualFin.getHours();
			const minutosf = fechaHoraActualFin.getMinutes();

			// formatea horas y minutos con ceros a la izquierda si es necesario
			this.tareaR.horafinalizacion = horasf.toString().padStart(2, '0');
			this.tareaR.minutofinalizacion = minutosf.toString().padStart(2, '0');

			this.horaFin = this.tareaR.horafinalizacion + ':' + this.tareaR.minutofinalizacion;

			// obtiene año, mes y día
			const aniof = fechaHoraActualFin.getFullYear();
			const mesf = (fechaHoraActualFin.getMonth() + 1).toString().padStart(2, '0'); // Nota: getMonth devuelve meses de 0 a 11
			const diaf = fechaHoraActualFin.getDate().toString().padStart(2, '0');

			// construye la cadena en formato AAAA-MM-DD
			this.fechafin = `${aniof}-${mesf}-${diaf}`;
		}
	}

	cambiarEstadoFiltro() {
		this.mostrarFiltros = !this.mostrarFiltros;
	}

	cargaEdemco() {
		this.loading = true;
		this.macroService.cargaEdemco().subscribe(
			response => {
				this.loading = false;
				alert("Se estan cargando las actividades, favor esperar unos minutos y recargar");
			}, error => {
				this.loading = false;
				this.controlarError(error);
			});

	}

	cancelarCreacion(id) {
		this.detenerCronometro();
		this.loading = true;
		this.macroService.elimiarActividades([id]).subscribe(
			response => {
			  this.loading = false;
			  this.servicioAlerta.advertencia("Se ha cancelado la creacion de la actividad");
			}, error => {
			  this.loading = false;
			  this.servicioAlerta.error("Ha ocurrido un error cancelando la creacion de la actividad");
			}
		);
		this.campoBusquedaFormulario = '';
		this.formularioSeleccionado = '';
		this.formulariosBusqueda = this.formularios;
		this.formularioToNewActivity = null;
		this.nuevaActividad = false;
		this.actividadSeleccionada = null;
	}

	cancelarNuevaActividad(){
		this.formularioSeleccionado = '';
		this.formularioToNewActivity = null;
	}

	recibirFirma(datos: File){
		this.selectedFile = datos;
	}
}


// WEBPACK FOOTER //
// ./src/app/actividades/por-formulario/por-formulario.component.ts